/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React from "react";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Modal,
  Row,
  Col,
  Spinner,
  Badge,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import DatePicker from "react-datepicker";
import { SingleSearchDropdownList } from "../../Common/Components/SingleSearchDropdownList";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFile,
  faFileImage,
  faFileExcel,
  faFilePdf,
  faFileCsv,
  faFileWord,
  faPlus,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import { Typeahead } from "react-bootstrap-typeahead";
import Dropzone from "react-dropzone";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { FiChevronDown } from "react-icons/fi";
import "./slideout.scss";
import "./transferSlideout.scss";
import { resolve, reject } from "q";
import { Register as registersevice } from "../../Common/Services/Register";
import { ToastContainer, toast } from "react-toastify";
import { Hotel } from "../../Common/Services/Hotel";
import { TransactionLogHistory } from "./TransactionLogHistory";
import { Journal as Journalsevice } from "../../Common/Services/Journal";
import { confirmAlert } from "react-confirm-alert";
import { RoleSubPermissionSetting, IPageSubPermissionRole, } from "../../Common/Services/RoleSubPermissionSetting";
import { CommentBox } from "../../Common/Components/CommentBox";
import MasterRoleLock from "../../Common/Assets/Images/icons/forecast-lock.svg";
import { Utils } from "../../Common/Utilis";
import ScrollContainer from "react-indiana-drag-scroll";
import PDFViewerNonInvoice from "./pdfviewerNonInvoice";
import _ from "lodash";
import moment from "moment";

let docViewerFiles: any = [];
let routeLeavingGuard: any = null;
export class TransferSlideout extends React.Component<any, any> {
  private ChildComment: any;
  private parentScroll: any;
  private footerchk: any;
  private scrollheight: any;
  render() {
    const highlightDates = [new Date()];
    let isEditPermission =
      this.state.hasEditPermission === "No" ||
      this.state.hasReimbursement ||
      this.state.hasCheckEntry ||
      this.state.noEditPermission ||
      this.state.isError === "NotEdit" ||
      this.state.AccPerList.length === 0 ||
      this.state.isTrEntryPaid;

    let isEditPermissionForCOA =
      this.state.hasEditPermission === "No" ||
      this.state.noEditPermission ||
      this.state.isError === "NotEdit" ||
      this.state.AccPerList.length === 0;

    let saveBtnDisable =
      this.state.newSelectedfiles.length > 0 ||
      isEditPermissionForCOA ||
      this.state.isDisable;
    const toggleSwitch = (event: any) => {
      this.setState({ defaultView: event });
      $(".scroll-area").animate({ scrollTop: 0 }, 500);
    };
    const handleUpdate = (newtext) => {
      toggleSwitch("doc-view");
      setTimeout(function () {
        let currentPos: any = $(`#${newtext}`).offset()?.top;
        let marginArea = currentPos - 138;
        $(".scroll-area").animate({ scrollTop: marginArea }, 500);
      }, 500);
    };

    const handleUpdateFiles = (docFiles) => {
      docViewerFiles.push(docFiles);
    };

    const showBulkSelect = (type) => {
      this.setState({ bulkSelect: type === "show" ? true : false });
      for (let i = 0; i < this.state.savedfiles.length; i++) {
        this["myRef" + i].current.showBulkSelect();
      }
    };

    const checkBulkSelect = (type, totalpage) => {
      if (totalpage === 0) {
        this.footerchk.current.labels[0].innerHTML = "No Page Selected";
      } else if (totalpage === 1) {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Page Selected";
      } else {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Pages Selected";
      }
      if (type === "removeAll") {
        this.footerchk.current.indeterminate = false;
        this.footerchk.current.checked = false;
      } else {
        if (type === "helf") {
          this.footerchk.current.indeterminate = true;
        } else {
          this.footerchk.current.indeterminate = false;
          this.footerchk.current.checked = true;
        }
      }
    };

    const currentView = this.state.defaultView;
    const savedfilesCount = this.state.savedfiles.length;
    const allsavedfiles = this.state.savedfiles;
    let hideZoombtn = allsavedfiles.length === 1 && allsavedfiles[0].name.split(".").pop().includes("xls".toLocaleLowerCase());
    let NoDelPermission = false;
    const files = this.state.newSelectedfiles.map((file, index) => {
      return (
        <>
          <li key={file.name}>
            <div className="d-flex align-items-center justify-content-start">
              <div className="icon">
                {file?.type?.split("/")[0] === "image" && (
                  <FontAwesomeIcon icon={faFileImage} />
                )}
                {file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) === "pdf" && <FontAwesomeIcon icon={faFilePdf} />}
                {file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) === "xlsx" && <FontAwesomeIcon icon={faFileExcel} />}
                {file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) === "csv" && <FontAwesomeIcon icon={faFileCsv} />}
                {file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) === "word" && <FontAwesomeIcon icon={faFileWord} />}
                {file?.type?.split("/")[0] !== "image" &&
                  file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  ) !== "pdf" &&
                  file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  ) !== "xlsx" &&
                  file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  ) !== "csv" &&
                  file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  ) !== "word" && <FontAwesomeIcon icon={faFile} />}
              </div>
              <div className="file-info d-flex">
                <div className="name-loader">
                  <div className="name d-flex">
                    <div className="full-name">{file.name}</div>
                  </div>
                </div>
                <div className="formate-percentage">
                  <div className="formate d-flex justify-content-center align-items-center">
                    {file?.name.substring(
                      file?.name.lastIndexOf(".") + 1,
                      file?.name.length
                    )}
                  </div>
                </div>
              </div>
              <div className="action">
                {this.state.newSelectedfiles.length > 0 ? (
                  <Spinner
                    size="sm"
                    title="Uploading..."
                    animation="border"
                    variant="success"
                  />
                ) : (
                  <Dropdown
                    className="more-action"
                    alignRight
                    onSelect={(event: any) =>
                      this.handleSelectFileUpload(event, file, index)
                    }
                  >
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more"
                      id="dropdown-more"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {this.state.moreActionFileUpload.map(
                        (item: any, idx: any) => (
                          <>
                            <Dropdown.Item
                              className={
                                isEditPermission &&
                                  this.state.moreActionFileUpload[idx]
                                    .eventKey === "delete"
                                  ? "isHide"
                                  : ""
                              }
                              eventKey={
                                this.state.moreActionFileUpload[idx].eventKey
                              }
                              key={item?.name}
                            >
                              {this.state.moreActionFileUpload[idx].name}
                            </Dropdown.Item>
                          </>
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
          </li>
        </>
      );
    });

    const files1 = this.state.savedfiles.map((file, index) => (
      <>
        <li key={file.name}>
          <div className="d-flex align-items-center justify-content-start">
            <div className="icon">
              {file?.type?.split("/")[0] === "image" && (
                <FontAwesomeIcon icon={faFileImage} />
              )}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "pdf" && <FontAwesomeIcon icon={faFilePdf} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "xlsx" && <FontAwesomeIcon icon={faFileExcel} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "csv" && <FontAwesomeIcon icon={faFileCsv} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "word" && <FontAwesomeIcon icon={faFileWord} />}
              {file?.type?.split("/")[0] !== "image" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "pdf" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "xlsx" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "csv" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "word" && <FontAwesomeIcon icon={faFile} />}
            </div>
            <div className="file-info d-flex">
              <div className="name-loader">
                <div className="name d-flex">
                  <div className="full-name">{file.name}</div>
                </div>
              </div>
              <div className="formate-percentage">
                <div className="formate d-flex justify-content-center align-items-center">
                  {file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  )}
                </div>
              </div>
            </div>
            <div className="action">
              <Dropdown
                className="more-action"
                alignRight
                onSelect={(event: any) =>
                  this.handleSelectFileUpload(event, file, index)
                }
              >
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {file.fileUniqueno > 0 && (
                    <>
                      <Dropdown.Item
                        className={this.state.hasRecouncil ? "isHide" : ""}
                        eventKey="deleteFile"
                      >
                        Delete
                      </Dropdown.Item>
                      <Dropdown.Item eventKey="download">
                        Download
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </li>
      </>
    ));
    let isSplitCondition = this.state.hasRecouncil ? (<Badge className="badge">Reconciled</Badge>) : (<Badge className="badge">Unreconciled</Badge>);
    let enabledFeild = isEditPermissionForCOA ? "" : "enabledFeild";
    let isBankSyncTransfer = this.props?.pageType === "BankSyncTransfer";
    let isBankSyncCheckW = (isBankSyncTransfer && this.props?.accDetails?.slideType?.toString().toLowerCase() === "checkwithdrawal");
    let isBankSyncWithdrawal = (isBankSyncTransfer && (isBankSyncCheckW || this.props?.accDetails?.slideType?.toString().toLowerCase() === "withdrawal"));
    return (
      <div
        className="transaction-slideout pos-fxd index-1000"
        onKeyDown={(e) => this.hasEditAccess(e)}
      >
        {/* <ToastContainer
          autoClose={3000}
          containerId={"SaveTransfer"}
          enableMultiContainer
        /> */}
        {this.state.showChangeLogModal && (
          <TransactionLogHistory
            payPeriodStartDate={""}
            payPeriodEndDate={""}
            accType={"transfer"}
            showChangeLogModal={this.state.showChangeLogModal}
            showHideChangeLogModal={this.showHideChangeLogModal}
            hotelName={""}
            hotelId={0}
            hideCrossAndClearFilters={false}
            shiftId={this.props.uniqueNo}
            shiftDate={""}
          />
        )}

        <div className="d-flex">
          {!this.state.isOpenViewer && (
            <div
              className="back-drop  viewer-panel opacity"
              onClick={() => this.hideSlideOut()}
            ></div>
          )}
          {this.state.isOpenViewer && (
            <div className="back-drop viewer-panel">
              <div className="header-panel d-flex justify-content-between align-items-center">
                <div className="page-ttl">Attachments</div>
                <div className="toggle-button">
                  <ButtonGroup aria-label="Basic example">
                    <ToggleButtonGroup
                      type="radio"
                      name="options"
                      value={this.state.defaultView}
                      onChange={toggleSwitch}
                    >
                      <ToggleButton value={"doc-view"}>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6159 9.34082 13.2709C9.34082 13.93 9.64999 14.3959 10.16 14.3959C10.6742 14.3959 10.9692 13.9059 10.9692 13.2509C10.9692 12.6459 10.6792 12.1267 10.155 12.1267Z" />
                          <path d="M11.6666 1.66663H4.99992C4.55789 1.66663 4.13397 1.84222 3.82141 2.15478C3.50885 2.46734 3.33325 2.89127 3.33325 3.33329V16.6666C3.33325 17.1087 3.50885 17.5326 3.82141 17.8451C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8451C16.491 17.5326 16.6666 17.1087 16.6666 16.6666V6.66663L11.6666 1.66663ZM11.6666 7.49996H10.8333V3.33329L14.9999 7.49996H11.6666Z" />
                        </svg>
                      </ToggleButton>
                      <ToggleButton value={"grid-view"}>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V11.6667C17.5 11.4457 17.4122 11.2337 17.2559 11.0774C17.0996 10.9211 16.8877 10.8333 16.6667 10.8333H11.6667C11.4457 10.8333 11.2337 10.9211 11.0774 11.0774C10.9211 11.2337 10.8333 11.4457 10.8333 11.6667V16.6667C10.8333 16.8877 10.9211 17.0996 11.0774 17.2559C11.2337 17.4122 11.4457 17.5 11.6667 17.5Z" />
                        </svg>
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </ButtonGroup>
                </div>
                <div className="action d-flex">
                  {this.state.isMapped.toString().toLowerCase() ===
                    "Yes".toString().toLowerCase() && (
                      <button type="button" className="btn wht-bg cross">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.0003 13.3333C11.8387 13.3333 13.3337 11.8383 13.3337 9.99996C13.3337 8.16163 11.8387 6.66663 10.0003 6.66663C8.16199 6.66663 6.66699 8.16163 6.66699 9.99996C6.66699 11.8383 8.16199 13.3333 10.0003 13.3333ZM10.0003 8.33329C10.9037 8.33329 11.667 9.09663 11.667 9.99996C11.667 10.9033 10.9037 11.6666 10.0003 11.6666C9.09699 11.6666 8.33366 10.9033 8.33366 9.99996C8.33366 9.09663 9.09699 8.33329 10.0003 8.33329Z"
                            fill="white"
                          />
                          <path
                            d="M2.37086 13.4466L3.20419 14.8883C3.64669 15.6525 4.71169 15.9391 5.47919 15.4966L5.92003 15.2416C6.40503 15.6225 6.93753 15.935 7.50003 16.1683V16.6666C7.50003 17.5858 8.24753 18.3333 9.16669 18.3333H10.8334C11.7525 18.3333 12.5 17.5858 12.5 16.6666V16.1683C13.0625 15.935 13.595 15.6225 14.08 15.2425L14.5209 15.4975C15.29 15.9391 16.3525 15.6541 16.7967 14.8883L17.6292 13.4475C18.0892 12.6516 17.8159 11.63 17.02 11.1708L16.5992 10.9275C16.6442 10.6183 16.6667 10.3091 16.6667 9.99996C16.6667 9.69079 16.6442 9.38079 16.5992 9.07413L17.02 8.83079C17.8159 8.37079 18.0892 7.34996 17.6292 6.55413L16.7967 5.11329C16.3542 4.34663 15.29 4.05913 14.5209 4.50329L14.08 4.75829C13.595 4.37746 13.0625 4.06496 12.5 3.83163V3.33329C12.5 2.41413 11.7525 1.66663 10.8334 1.66663H9.16669C8.24753 1.66663 7.50003 2.41413 7.50003 3.33329V3.83163C6.93753 4.06496 6.40503 4.37746 5.92003 4.75746L5.47919 4.50246C4.70919 4.05996 3.64586 4.34663 3.20336 5.11246L2.37086 6.55329C1.91086 7.34913 2.18419 8.37079 2.98003 8.82996L3.40086 9.07329C3.35586 9.38079 3.33336 9.69079 3.33336 9.99996C3.33336 10.3091 3.35586 10.6183 3.40086 10.9258L2.98003 11.1691C2.18419 11.6291 1.91086 12.6508 2.37086 13.4466ZM5.14253 11.1483C5.04836 10.7708 5.00003 10.3841 5.00003 9.99996C5.00003 9.61496 5.04836 9.22829 5.14169 8.85163C5.23169 8.49079 5.07253 8.11413 4.75003 7.92829L3.81419 7.38663L4.64586 5.94579L5.60003 6.49746C5.92003 6.68163 6.32253 6.63496 6.59003 6.37913C7.15919 5.83996 7.84586 5.43663 8.57669 5.21329C8.92753 5.10663 9.16669 4.78246 9.16669 4.41663V3.33329H10.8334V4.41663C10.8334 4.78246 11.0725 5.10663 11.4234 5.21329C12.1542 5.43746 12.8409 5.83996 13.41 6.37913C13.6775 6.63496 14.0817 6.68079 14.4 6.49746L15.3534 5.94663L16.1867 7.38746L15.25 7.92829C14.9275 8.11496 14.7684 8.49163 14.8584 8.85163C14.9517 9.22829 15 9.61496 15 9.99996C15 10.3841 14.9517 10.7708 14.8575 11.1483C14.7684 11.5091 14.9275 11.8858 15.25 12.0716L16.1859 12.6125L15.3542 14.0533L14.4 13.5025C14.0809 13.3183 13.6775 13.3641 13.41 13.6208C12.8409 14.16 12.1542 14.5633 11.4234 14.7866C11.0725 14.8933 10.8334 15.2175 10.8334 15.5833L10.835 16.6666H9.16669V15.5833C9.16669 15.2175 8.92753 14.8933 8.57669 14.7866C7.84586 14.5625 7.15919 14.16 6.59003 13.6208C6.43169 13.4691 6.22503 13.3916 6.01669 13.3916C5.87336 13.3916 5.73003 13.4283 5.60003 13.5033L4.64669 14.055L3.81336 12.6141L4.75003 12.0716C5.07253 11.8858 5.23169 11.5091 5.14253 11.1483Z"
                            fill="white"
                          />
                        </svg>
                      </button>
                    )}
                  <button
                    type="button"
                    className="btn wht-bg cross"
                    onClick={this.OpenViewer}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <ScrollContainer
                className={`scroll-area ${this.state.modalOpen === "yes" ? "modal-open" : ""
                  } ${currentView !== "doc-view" ? "grid-sec" : "doc-sec"}`}
                ref={this.scrollheight}
                hideScrollbars={false}
              >
                {this.state.savedfiles.map((file: any, i: any) => {
                  return (
                    <div key={file?.rno}
                      className={this.state.bulkSelect ? "footer-enable" : ""}
                    >
                      <div
                        className={
                          currentView !== "doc-view" ? "grid-sec" : "doc-sec"
                        }
                      >
                        {this.state.isAttachmentLoading ? (
                          <div className="d-flex attachment-Viewer-loader justify-content-center">
                            <Spinner
                              className="d-flex"
                              style={{ margin: "auto" }}
                              animation="border"
                              variant="light"
                            />
                          </div>
                        ) : (
                          <div className="nonInvoicePDFViewer">
                            <PDFViewerNonInvoice
                              ref={this["myRef" + i]}
                              scrollAreaHeight={this.state.scrollAreaHeight}
                              isModalOpen={this["isModalOpen"]}
                              uniqueno={this.state.invoiceUniqueNo}
                              filePreview={file.fileCode}
                              defaultView={currentView}
                              fileNo={file.fileUniqueno}
                              fileCount={savedfilesCount}
                              fileName={file.name}
                              docFile={allsavedfiles}
                              updateState={handleUpdate}
                              updateFiles={handleUpdateFiles}
                              showBulkSelect={showBulkSelect}
                              checkBulkSelect={checkBulkSelect}
                              handleFileCheckBox={this["handleFileCheckBox"]}
                              handleUpdatedFile={this["handleUpdatedFile"]}
                              handleincompleteFile={this["handleincompleteFile"]}
                              saveSplitFile={this["saveSplitFile"]}
                              pageType={"Transfer"}
                              handleRotate={this["handleRotate"]}
                              handlePageRemove={this["handlePageRemove"]}
                              selectedChk={this.state.selectedChk}
                              selectedZoom={this.state.currentZoom}
                              NoDelPermission={NoDelPermission}
                              isEditPermission={!this.state.hasRecouncil}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
                {!this.state.isAttachmentLoading && !hideZoombtn && (
                  <>
                    {currentView === "doc-view" && (
                      <div className="zoom-btn">
                        <ButtonGroup vertical>
                          <Button
                            onClick={(e) => this.handleZoom("zoomIn")}
                            disabled={
                              this.state.currentZoom >= 3.375 ? true : false
                            }
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </Button>
                          <Button
                            onClick={(e) => this.handleZoom("zoomOut")}
                            disabled={
                              this.state.currentZoom <= 0.44 ? true : false
                            }
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </Button>
                        </ButtonGroup>
                      </div>
                    )}
                  </>
                )}
                {this.state.bulkSelect && (
                  <div className="footer-section d-flex align-items-center">
                    <Form.Check
                      custom
                      type="checkbox"
                      key={"custom-footer"}
                      id={"custom-footer"}
                      label={"No Page Selected"}
                      onChange={(e: any) => this.handleAllCheckbox(e)}
                      ref={this.footerchk}
                    />
                    {!this.state.hasRecouncil && (
                      <button
                        type="button"
                        onClick={this.handleBulkRemove}
                        className="btn-outline-primary btn btn-primary"
                      >
                        Remove
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={this.handleBulkRotate}
                      className="btn-outline-primary btn btn-primary mr-auto"
                    >
                      Rotate
                    </button>
                    <button
                      type="button"
                      className="btn wht-bg cross"
                      onClick={this.hideBulkselect}
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </ScrollContainer>
            </div>
          )}

          <Container
            fluid
            className={
              this.state.isStateChanged
                ? "body-sec viewer-panel"
                : "body-sec viewer-panel footer-disable"
            }
            ref={this.parentScroll}
          >
            <div className="page-heading pos-sticky underline d-flex">
              <div className="hid-set d-flex align-items-center">
                {this.state.BackHIDNM}
              </div>

              <div className="mr-auto d-flex align-items-center">
                Transfer
                {this.state.showBadge && (
                  <>
                    {this.state.AccPerList.length > 0 && (
                      <>
                        {this.state.voidData.isVoid ? (<Badge className="badge">Void</Badge>) : isSplitCondition}
                        {this.state.hasEditPermission === "No" && (
                          <img
                            className="ml-2"
                            src={MasterRoleLock}
                            alt="ScheduleLock"
                          />
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
              <div className="action-group d-flex">
                {!isBankSyncTransfer && this.props.uniqueNo === 0 && (
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label="Repeating"
                    checked={this.state.RepType}
                    onChange={(event: any) =>
                      this.handleChange(event, "repeat")
                    }
                  />
                )}
                {this.props.isFromRepeating && (
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label="Repeating"
                    checked={this.state.RepType}
                    disabled={true}
                  />
                )}

                {!this.props?.isFromRepeating ? (
                  <>
                    {this.state.formData.actionType !== "copy" && (
                      <>
                        <Dropdown
                          className={
                            this.state.AccPerList.length === 0
                              ? "disabled-area more-action"
                              : "more-action"
                          }
                          alignRight
                          onSelect={this.handleSelect}
                        >
                          <Dropdown.Toggle
                            className="btn-outline-primary btn btn-primary more"
                            id="dropdown-more"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                              <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                              <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() =>
                                this.onMoreActionChange("changeLog")
                              }
                              eventKey={"Change Log"}
                              key={"changeLog"}
                            >
                              {"Change Log"}
                            </Dropdown.Item>
                            {this.state.hasDeleteAccess &&
                              this.state.hasDeletePermission && (
                                <Dropdown.Item
                                  className={
                                    this.state.isError === "NotEdit" ||
                                      this.state.hasCheckEntry ||
                                      this.state.isReconcile ||
                                      this.state.hasRecouncil
                                      ? "isHide"
                                      : ""
                                  }
                                  onClick={() =>
                                    this.onMoreActionChange("deleteTEntry")
                                  }
                                  eventKey={"deleteTEntry"}
                                  key={"deleteTEntry"}
                                >
                                  <>{"Delete"}</>
                                </Dropdown.Item>
                              )}
                            {this.props.uniqueNo !== 0 && (
                              <>
                                {!this.state.hasReimbursement &&
                                  !this.state.voidData.isVoid &&
                                  !this.state.noEditPermission && (
                                    <Dropdown.Item
                                      className={
                                        this.state.isError === "NotEdit"
                                          ? "isHide"
                                          : ""
                                      }
                                      onClick={() =>
                                        this.onMoreActionChange("copy")
                                      }
                                      eventKey={"copy"}
                                      key={"copy"}
                                    >
                                      {"Copy"}
                                    </Dropdown.Item>
                                  )}
                                {this.props?.isfromSearch ? (
                                  <>
                                    {this.state.voidData.isVoidPermSearch ===
                                      "Yes" && (
                                        <>
                                          {this.props.transferRequest
                                            ?.acctType === "O" &&
                                            this.state.voidData.voidShow ===
                                            "Show" &&
                                            !this.state.voidData.isVoid &&
                                            this.state.voidData?.accountStatus?.toLowerCase() ===
                                            "active" &&
                                            this.state.voidData.accountStatusTo?.toLowerCase() ===
                                            "active" &&
                                            this.state.voidData.voidPermission ===
                                            "Yes" &&
                                            this.state.voidData.fromPer?.toLowerCase() ==
                                            "yes" && (
                                              <Dropdown.Item
                                                className={
                                                  this.state.isError === "NotEdit"
                                                    ? "isHide"
                                                    : ""
                                                }
                                                onClick={() =>
                                                  this.onMoreActionChange("void")
                                                }
                                                eventKey={"void"}
                                                key={"void"}
                                              >
                                                Void
                                              </Dropdown.Item>
                                            )}
                                        </>
                                      )}
                                  </>
                                ) : (
                                  <>
                                    {this.props.transferRequest?.acctType ===
                                      "O" &&
                                      this.state.voidData.voidShow === "Show" &&
                                      !this.state.voidData.isVoid &&
                                      this.state.voidData?.accountStatus?.toLowerCase() ===
                                      "active" &&
                                      this.state.voidData.accountStatusTo?.toLowerCase() ===
                                      "active" &&
                                      this.state.voidData.voidPermission ===
                                      "Yes" &&
                                      this.state.voidData.fromPer?.toLowerCase() ==
                                      "yes" && (
                                        <Dropdown.Item
                                          className={
                                            this.state.isError === "NotEdit"
                                              ? "isHide"
                                              : ""
                                          }
                                          onClick={() =>
                                            this.onMoreActionChange("void")
                                          }
                                          eventKey={"void"}
                                          key={"void"}
                                        >
                                          Void
                                        </Dropdown.Item>
                                      )}
                                  </>
                                )}
                              </>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </>
                    )}
                  </>
                ) : (
                  this.state.hasDeletePermission && (
                    <Dropdown
                      className={
                        this.state.AccPerList.length === 0
                          ? "disabled-area more-action"
                          : "more-action"
                      }
                      alignRight
                      onSelect={this.handleSelect}
                    >
                      <Dropdown.Toggle
                        className="btn-outline-primary btn btn-primary more"
                        id="dropdown-more"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                          <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                          <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          className={
                            this.state.isError === "NotEdit" ? "isHide" : ""
                          }
                          onClick={() =>
                            this.onMoreActionChange("deleteTEntry")
                          }
                          eventKey={"deleteTEntry"}
                          key={"deleteTEntry"}
                        >
                          <>{"Delete"}</>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )
                )}
                <button
                  type="button"
                  className="btn wht-bg cross"
                  onClick={this.hideSlideOut}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                      fill="#84888C"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className={`${isEditPermission ? "hasDisabledArea" : ""} ${!this.state.accountingPeriodActive ? "" : enabledFeild}`}>
              <div className="filter-sec">
                <div className="d-flex">
                  <div className="d-flex flex-wrap mr-auto">
                    {!this.state.RepType && (
                      <>
                        <Form.Group className="rm-bottom-margin">
                          <Form.Label
                            className={
                              this.state.hasRecouncil ? "disabled-area" : ""
                            }
                          >
                            Transfer Date
                          </Form.Label>
                          <div className="date-picker calender-picker">
                            <div className="drop-arrow">
                              <svg
                                width="8"
                                height="6"
                                viewBox="0 0 8 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                                  fill="#3F4347"
                                />
                              </svg>
                            </div>
                            {isEditPermission || isBankSyncTransfer ||
                              this.state.isCheckEntry ||
                              this.state.hasRecouncil ? (
                              <Form.Control
                                disabled={true}
                                type="text"
                                value={this.state.formData.Date}
                              />
                            ) : (
                              <DatePicker
                                tabIndex={this.state.tabEnable}
                                className="form-control"
                                placeholderText={"MM/DD/YY"}
                                dateFormat="MM/dd/yy"
                                highlightDates={
                                  this.state.formData.Date === null &&
                                  highlightDates
                                }
                                selected={
                                  this.state.formData.Date === null
                                    ? ""
                                    : new Date(this.state.formData.Date)
                                }
                                onChange={(event: any) =>
                                  this.handleChange(event, "Date")
                                }
                              />
                            )}
                          </div>
                        </Form.Group>
                        <div className="mr-auto d-flex">
                          <Form.Group className="rm-bottom-margin enable-controll">
                            <Form.Label>Accounting Period</Form.Label>
                            <div className="single-select">
                              {this.state.AccPerList.length > 0 ? (
                                <SingleDropdownListWithoutSearch
                                  id={"accountingPeriod"}
                                  itemList={this.state.AccPerList}
                                  handleSelectedItem={(event: any) =>
                                    this.handleSelectedData(event, "")
                                  }
                                  defaultItem={this.state.formData.AccPer}
                                  defaultText={"Accouting Period"}
                                  defaultName={this.state.formData.AccPer}
                                  controlID="6"
                                />
                              ) : (
                                <div className="disabled-area">
                                  <Dropdown className="more-action bg-blue single-select-image">
                                    <Dropdown.Toggle
                                      id="Modal-hid"
                                      className="filter-btn"
                                    >
                                      <div className="d-flex align-items-center">
                                        <div className="txt-area">
                                          {this.state.formData.AccPer}
                                        </div>
                                        <div className="drop-arrow ml-0 d-flex">
                                          <FiChevronDown />
                                        </div>
                                      </div>
                                    </Dropdown.Toggle>
                                  </Dropdown>
                                </div>
                              )}
                            </div>
                          </Form.Group>
                        </div>
                        {this.state.hasCheckEntry && (
                          <div className="d-flex">
                            {this.state.AccPerList.length > 0 && (
                              <>
                                <Form.Group>
                                  <Form.Label>Check #</Form.Label>
                                  <Form.Control
                                    className="transferControl check-number"
                                    type="text"
                                    value={this.state.formData.eCheckNo}
                                    placeholder="Check #"
                                  />
                                </Form.Group>
                                <Form.Group>
                                  <Form.Label>Check Date</Form.Label>
                                  <Form.Control
                                    className="transferControl check-date"
                                    type="text"
                                    value={this.state.formData.eCheckDate}
                                    placeholder="Check Date"
                                  />
                                </Form.Group>
                              </>
                            )}
                          </div>
                        )}
                      </>
                    )}

                    {this.state.RepType && (
                      <>
                        <Form.Group className="rm-bottom-margin">
                          <Form.Label>Repeat</Form.Label>
                          {/* <div className="single-select">
                            <Form.Control
                              id="transferRepeat"
                              type="text"
                              tabIndex={this.state.tabEnable}
                              placeholder="Enter Account Name"
                              value={"Monthly"}
                              disabled
                            />
                          </div> */}
                          <div className="single-select">
                            <Dropdown className="more-action bg-blue single-select-image repeat">
                              <Dropdown.Toggle variant="success" id="dropdown-basic" className="filter-btn">
                                <div className="d-flex align-items-center">
                                  <div className="txt-area">
                                    <EllipsisWithTooltip placement="bottom">
                                      {this.state.repeatList.filter((item) => item.name.toLowerCase() === this.state.selectedRepeatType?.toLowerCase()).length > 0 ?
                                        this.state.repeatList.filter((item) => item.name.toLowerCase() === this.state.selectedRepeatType?.toLowerCase())[0].displayName : "Select"}
                                    </EllipsisWithTooltip>
                                  </div>
                                  <div className="drop-arrow ml-auto">
                                    <FiChevronDown />
                                  </div>
                                </div>
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                {this.state.repeatList.map(
                                  (item: any, idx: any) => (
                                    <Dropdown.Item
                                      eventKey={item.displayName}
                                      onClick={() => this.onSelectRepeatType(item)}
                                    >
                                      <EllipsisWithTooltip placement="bottom">
                                        {item.displayName}
                                      </EllipsisWithTooltip>
                                    </Dropdown.Item>
                                  )
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </Form.Group>
                        <Form.Group className="rm-bottom-margin">
                          <Form.Label>Transfer Date</Form.Label>
                          <div className="date-picker calender-picker">
                            <div className="drop-arrow">
                              <svg
                                width="8"
                                height="6"
                                viewBox="0 0 8 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                                  fill="#3F4347"
                                />
                              </svg>
                            </div>
                            <DatePicker
                              tabIndex={this.state.tabEnable}
                              className="form-control"
                              placeholderText={"MM/DD/YY"}
                              dateFormat="MM/dd/yy"
                              selected={
                                this.state.formData.Date === null
                                  ? ""
                                  : new Date(this.state.formData.Date)
                              }
                              onChange={(event: any) =>
                                this.handleChange(event, "Date")
                              }
                            />
                          </div>
                        </Form.Group>
                        <div className="mr-auto d-flex">
                          <Form.Group className="rm-bottom-margin">
                            <Form.Label>End Date</Form.Label>
                            <div className="date-picker calender-picker">
                              <div className="drop-arrow">
                                <svg
                                  width="8"
                                  height="6"
                                  viewBox="0 0 8 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                                    fill="#3F4347"
                                  />
                                </svg>
                              </div>
                              <DatePicker
                                tabIndex={this.state.tabEnable}
                                className="form-control"
                                placeholderText={"None"}
                                dateFormat="MM/dd/yy"
                                selected={
                                  this.state.formData.EndDate === ""
                                    ? ""
                                    : new Date(this.state.formData.EndDate)
                                }
                                onBlur={(event) =>
                                  this.endDatefocousOut(event.target.value)
                                }
                                onChange={(event: any) =>
                                  this.handleChange(event, "endDate")
                                }
                              />
                            </div>
                          </Form.Group>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="total-amount inpute">
                    <div className="label margin-Bottom">AMOUNT</div>
                    <div className="amount disabled-area">
                      {Utils.currencyFormat(
                        this.state.formData.TransTotalHeader
                      )}
                    </div>
                  </div>
                </div>
                <div className="notes-section">
                  <Form.Group>
                    <Form.Label
                      className={this.state.hasRecouncil ? "disabled-area" : ""}
                    >
                      Notes
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      wrap="hard"
                      rows={3}
                      id="transferNotes"
                      disabled={this.state.hasRecouncil || isEditPermission}
                      value={this.state.formData.Description}
                      maxLength={99}
                      onChange={(event: any) =>
                        this.handleChange(event, "notes")
                      }
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="transactions-list hasBorderBottom">
                <Row>
                  <Col>
                    <div className="transCol leftCol">
                      <div
                        className={
                          this.state.hasRecouncil
                            ? "disabled-area trasfarHeader trFrom"
                            : "trasfarHeader trFrom"
                        }
                      >
                        <strong className="transferSRNo">1.</strong>
                        <strong>Transfer FROM</strong>
                        <span>{this.state.BackHIDNM}</span>
                      </div>

                      {this.state.formData.HIDTo !== "" && (
                        <div className="trasfarBody">
                          <strong className="transferSRNo">2.</strong>
                          <Form.Group>
                            <div className="seprateLabel">
                              <Form.Label
                                className={
                                  this.state.hasRecouncil ||
                                    isEditPermission ||
                                    this.state.isCheckEntry
                                    ? "disabled-area"
                                    : ""
                                }
                              >
                                Account
                              </Form.Label>
                              {this.state.fAccBalData.length > 0 ? (
                                <>
                                  {this.state.fAccBalShow ? (
                                    <div className="ml-2 single-loader single-balance-loader loadingAnimation"></div>
                                  ) : (
                                    <Form.Label
                                      className={
                                        this.state.hasRecouncil
                                          ? "disabled-area d-flex"
                                          : " d-flex"
                                      }
                                    >
                                      {this.state.isGLPermission && (
                                        <>
                                          Balance:{" "}
                                          {Utils.currencyFormat(
                                            this.state.fAccBal
                                          )}
                                        </>
                                      )}
                                    </Form.Label>
                                  )}
                                </>
                              ) : (
                                <>
                                  {this.state.fAccBalShow && (
                                    <div className="ml-2 single-loader single-balance-loader loadingAnimation"></div>
                                  )}
                                </>
                              )}
                            </div>
                            <div
                              className={`${this.state.accountFromNamelist.length > 0
                                ? ""
                                : "disabled-area"
                                } singleSelect`}
                            >
                              <Dropdown
                                className={
                                  this.state.hasRecouncil ||
                                    isEditPermission ||
                                    this.state.isCheckEntry || isBankSyncWithdrawal
                                    ? "disabled-area more-action bg-blue single-select-image"
                                    : "more-action bg-blue single-select-image"
                                }
                              >
                                <Dropdown.Toggle
                                  id="Modal-hid"
                                  className="filter-btn"
                                  disabled={
                                    this.props?.isFromRepeating ||
                                    isEditPermission
                                  }
                                >
                                  <div className="d-flex align-items-center">
                                    <div className="txt-area">
                                      {this.state.faccountName}
                                    </div>
                                    <div className="drop-arrow ml-0 d-flex">
                                      <FiChevronDown />
                                    </div>
                                  </div>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="ddScrollableArea">
                                  {this.state.hasRecouncil || isEditPermission || this.state.isCheckEntry || isBankSyncWithdrawal ? (<></>) : (
                                    <>
                                      {this.state.accountFromNamelist.map((items, index) => {
                                        let taccountName = this.state.taccountName;
                                        if (items.name !== taccountName) {
                                          return (
                                            <Dropdown.Item
                                              disabled={this.state.hasRecouncil}
                                              className={
                                                items.status !== "Active"
                                                  ? "d-none"
                                                  : ""
                                              }
                                              onClick={(event: any) =>
                                                this.handleAccountFromList(
                                                  event,
                                                  items
                                                )
                                              }
                                              key={items?.oprID}
                                            >
                                              {items.name}
                                            </Dropdown.Item>
                                          )
                                        }
                                      }
                                      )}
                                    </>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </Form.Group>
                          <Form.Group className="enable-controll">
                            <Form.Label>COA</Form.Label>
                            <div className="more-action single-select-image dropdown singleSelect">
                              {this.state.COAList.length > 0 ? (
                                <Typeahead
                                  id="fromCOA"
                                  disabled={
                                    this.state.formData.isCOAPer1 !== "Yes" ||
                                    isEditPermissionForCOA ||
                                    this.state.hasReimbursement
                                  }
                                  onChange={(e) =>
                                    this.COAControl(e, "COAFrom")
                                  }
                                  renderMenuItemChildren={
                                    this.renderCOAItemChildren
                                  }
                                  options={this.state.COAList}
                                  placeholder="Select COA"
                                  selected={this.state.COAFromName}
                                  onKeyDown={(e) =>
                                    this.handleCOAKey(e, "COAFrom")
                                  }
                                />
                              ) : (
                                <Dropdown className="more-action disabled-area bg-blue single-select-image">
                                  <Dropdown.Toggle
                                    id="Modal-hid"
                                    className="filter-btn"
                                  >
                                    <div className="d-flex align-items-center">
                                      <div className="txt-area">Select COA</div>
                                      <div className="drop-arrow ml-0 d-flex">
                                        <FiChevronDown />
                                      </div>
                                    </div>
                                  </Dropdown.Toggle>
                                </Dropdown>
                              )}
                            </div>
                          </Form.Group>
                          <Row>
                            <Col lg={6} className="pr-2">
                              <Form.Group>
                                <Form.Label className={this.state.hasRecouncil || this.state.formData.isCOAPer1 !== "Yes" ? "disabled-area" : ""}>Amount</Form.Label>
                                <Form.Control
                                  type="text"
                                  id="transferAmount"
                                  value={this.state.formData.TransTotal}
                                  onChange={(event: any) =>
                                    this.handleChange(event, "TransTotal")
                                  }
                                  onFocus={(e: any) => this.amountFocus(e)}
                                  onBlur={(e: any) => this.amountBlur(e)}
                                  disabled={
                                    this.state.hasRecouncil ||
                                    this.state.formData.isCOAPer1 !== "Yes" ||
                                    isEditPermission || isBankSyncTransfer
                                  }
                                  placeholder="Amount"
                                  className="transferControl hasAmount"
                                  autoComplete="off"
                                />
                              </Form.Group>
                            </Col>
                            <Col lg={6} className="pl-2">
                              {this.state.hasOP &&
                                !this.state.hasReimbursement && (
                                  <Form.Group>
                                    {this.state.AccPerList.length > 0 && (
                                      <>
                                        <Form.Label>Type</Form.Label>
                                        <div className="singleSelect">
                                          <Dropdown
                                            className={`${(isBankSyncTransfer || this.state.hasRecouncil || isEditPermission || this.state.isCheckEntry)
                                              ? "disabled-area"
                                              : ""
                                              } more-action bg-blue single-select-image`}
                                          >
                                            <Dropdown.Toggle
                                              id="Modal-hid"
                                              className="filter-btn"
                                            >
                                              <div className="d-flex align-items-center">
                                                <div className="txt-area setwidth90">
                                                  {
                                                    this.state.formData
                                                      .PaymentMethod
                                                  }
                                                </div>
                                                <div className="drop-arrow ml-0 d-flex">
                                                  <FiChevronDown />
                                                </div>
                                              </div>
                                            </Dropdown.Toggle>
                                            {this.state.hasRecouncil ||
                                              isEditPermission ||
                                              this.state.isCheckEntry ? (
                                              <></>
                                            ) : (
                                              <Dropdown.Menu>
                                                <Dropdown.Item onClick={(event: any) => this.fromCheckType(event, "Manual ACH")}>Manual ACH</Dropdown.Item>
                                                {(!isBankSyncTransfer && !this.state.RepType) && (
                                                  <Dropdown.Item onClick={(event: any) => this.fromCheckType(event, "Check")}>Check</Dropdown.Item>
                                                )}
                                              </Dropdown.Menu>
                                            )}
                                          </Dropdown>
                                        </div>
                                      </>
                                    )}
                                  </Form.Group>
                                )}
                            </Col>
                          </Row>
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col>
                    <div className="transCol rightCol">
                      <div className="trasfarHeader trTO">
                        <div
                          className={
                            this.state.hasRecouncil ||
                              isEditPermission ||
                              this.state.isCheckEntry
                              ? "disabled-area"
                              : ""
                          }
                        >
                          <span className="transferRightArrow">
                            {this.rightArrow()}
                          </span>
                          <strong>Transfer TO</strong>
                        </div>
                        <div className="singleSelect">
                          {this.state.hasRecouncil ||
                            isEditPermission ||
                            this.state.isCheckEntry ? (
                            <Dropdown className="more-action disabled-area bg-blue single-select-image">
                              <Dropdown.Toggle
                                id="Modal-hid"
                                className="filter-btn"
                                disabled={
                                  this.props?.isFromRepeating ||
                                  isEditPermission
                                }
                              >
                                <div className="d-flex align-items-center">
                                  <div className="txt-area">
                                    {this.state.HIDToNM}
                                  </div>
                                  <div className="drop-arrow ml-0 d-flex">
                                    <FiChevronDown />
                                  </div>
                                </div>
                              </Dropdown.Toggle>
                            </Dropdown>
                          ) : (
                            <>
                              {this.state.hidListCount.length > 0 ? (
                                <SingleSearchDropdownList
                                  tabIndex={this.state.tabEnable}
                                  itemList={this.state.hidListCount}
                                  transferControl={this.transferControl.bind(
                                    this,
                                    "headerEhid"
                                  )}
                                  pageType="headerEhid"
                                  defaultItem={this.state.HIDToNM}
                                  defaultText={"Choose an EHID"}
                                  defaultName={this.state.HIDToNM}
                                  controlID="2"
                                  isFromRepeating={this.props?.isFromRepeating}
                                />
                              ) : (
                                <Dropdown className="more-action disabled-area bg-blue single-select-image">
                                  <Dropdown.Toggle
                                    id="Modal-hid"
                                    className="filter-btn"
                                    disabled={this.props?.isFromRepeating}
                                  >
                                    <div className="d-flex align-items-center">
                                      <div className="txt-area">
                                        {this.state.HIDToNM}
                                      </div>
                                      <div className="drop-arrow ml-0 d-flex">
                                        <FiChevronDown />
                                      </div>
                                    </div>
                                  </Dropdown.Toggle>
                                </Dropdown>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                      {this.state.formData.HIDTo !== "" && (
                        <div className="trasfarBody">
                          <span className="transferRightArrow">
                            {this.rightArrow()}
                          </span>
                          <Form.Group>
                            <div className="seprateLabel">
                              <Form.Label
                                className={
                                  this.state.hasRecouncil ||
                                    isEditPermission ||
                                    this.state.isCheckEntry
                                    ? "disabled-area"
                                    : ""
                                }
                              >
                                Account
                              </Form.Label>
                            </div>
                            <div
                              className={`${this.state.accountToNamelist.length > 0
                                ? ""
                                : "disabled-area"
                                } singleSelect`}
                            >
                              <Dropdown
                                className={
                                  this.state.hasRecouncil ||
                                    isEditPermission ||
                                    this.state.isCheckEntry
                                    ? "more-action bg-blue single-select-image disabled-area"
                                    : "more-action bg-blue single-select-image"
                                }
                              >
                                <Dropdown.Toggle
                                  id="Modal-hid"
                                  className="filter-btn"
                                  disabled={
                                    this.props?.isFromRepeating ||
                                    isEditPermission
                                  }
                                >
                                  <div className="d-flex align-items-center">
                                    <div className="txt-area">
                                      {this.state.taccountName}
                                    </div>
                                    <div className="drop-arrow ml-0 d-flex">
                                      <FiChevronDown />
                                    </div>
                                  </div>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="ddScrollableArea">
                                  {this.state.hasRecouncil ||
                                    isEditPermission ||
                                    this.state.isCheckEntry ? (
                                    <></>
                                  ) : (
                                    <>
                                      {this.state.accountToNamelist.map((items, index) => {
                                        if (items.name !== this.state.faccountName) {
                                          return (
                                            <Dropdown.Item
                                              disabled={this.state.hasRecouncil}
                                              className={items.status !== "Active" ? "d-none" : ""}
                                              onClick={(event: any) => this.handleAccountToList(items)}
                                              key={items?.oprID}
                                            >
                                              {items.name}
                                            </Dropdown.Item>
                                          )
                                        }
                                      })}
                                    </>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </Form.Group>
                          <Form.Group className="enable-controll">
                            <Form.Label>COA</Form.Label>
                            <div className="more-action single-select-image dropdown singleSelect">
                              {this.state.COAList.length > 0 ? (
                                <Typeahead
                                  id="toCOA"
                                  onChange={(e) => this.COAControl(e, "COATo")}
                                  options={this.state.COAList}
                                  disabled={
                                    this.state.formData.isCOAPer2 !== "Yes" ||
                                    isEditPermissionForCOA ||
                                    this.state.hasReimbursement
                                  }
                                  renderMenuItemChildren={
                                    this.renderCOAItemChildren
                                  }
                                  placeholder="Select COA"
                                  selected={this.state.COAToName}
                                  onKeyDown={(e) =>
                                    this.handleCOAKey(e, "COATo")
                                  }
                                />
                              ) : (
                                <Dropdown className="more-action disabled-area bg-blue single-select-image">
                                  <Dropdown.Toggle
                                    id="Modal-hid"
                                    className="filter-btn"
                                  >
                                    <div className="d-flex align-items-center">
                                      <div className="txt-area">Select COA</div>
                                      <div className="drop-arrow ml-0 d-flex">
                                        <FiChevronDown />
                                      </div>
                                    </div>
                                  </Dropdown.Toggle>
                                </Dropdown>
                              )}
                            </div>
                          </Form.Group>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="filter-sec upload-section">
              <Form.Group>
                {this.props.pageFrom !== undefined && this.props.pageFrom === "repeatingPage" ? (<></>) : (
                  <>
                    <div className="d-flex">
                      <Form.Label className="mr-auto">Attachments</Form.Label>
                      <div className="d-flex">
                        {this.state.savedfiles.length > 0 && (
                          <div className="upload-link">
                            <button type="button" className="btn wht-bg link-btn mr-auto" onClick={this.OpenViewer}>
                              {this.state.isOpenViewer ? "Close Viewer" : "Open Viewer"}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <Dropzone onDrop={this.onDrop}>
                      {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                        <section className={isDragActive ? "container upload-area default drag-active " : "container upload-area default"}>
                          <div>
                            <div id="droparea"
                              onKeyDown={(event: any) =>
                                this.handleKeyDown(event, "droparea")
                              }
                              {...getRootProps({
                                className: "dropzone d-flex align-items-center",
                                onClick:
                                  this.state.newSelectedfiles.length > 0 ||
                                    this.state.savedfiles.length > 0
                                    ? (event) => event.stopPropagation()
                                    : (event) => event,
                              })}
                            >
                              <input {...getInputProps()} />
                              {this.state.newSelectedfiles.length < 1 &&
                                this.state.savedfiles.length < 1 && (
                                  <p>
                                    Drag and drop Document or{" "}
                                    <span>browse files</span> to upload.
                                  </p>
                                )}
                              {(this.state.newSelectedfiles.length > 0 ||
                                this.state.savedfiles.length > 0) &&
                                isDragActive && (
                                  <p>Drag and drop Document here to upload.</p>
                                )}
                            </div>
                          </div>
                          {(this.state.newSelectedfiles.length > 0 ||
                            this.state.savedfiles.length > 0) && (
                              <aside className="d-flex flex-column file-area">
                                <ul>{files}</ul>
                                <ul>{files1}</ul>
                              </aside>
                            )}
                        </section>
                      )}
                    </Dropzone>
                    <div className="d-flex">
                      <>
                        {(this.state.newSelectedfiles.length > 0 ||
                          this.state.savedfiles.length > 0) && (
                            <div
                              className="upload-link mt-2 addAttachmentButton"
                            >
                              <button
                                type="button"
                                className="btn wht-bg link-btn mr-auto"
                              >
                                Add Attachment
                              </button>
                              <Form.Control
                                id="formControlsFile"
                                type="file"
                                multiple
                                onChange={(event: any) => this.onFileChange(event, "1")}
                                accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                              />
                            </div>
                          )}
                      </>
                    </div>
                  </>
                )}
              </Form.Group>
            </div>

            {this.state.isComment && !this.state.RepType && (
              <div className={this.state.isStateChanged ? "footer-show" : ""}>
                <CommentBox
                  ref={this.ChildComment}
                  hotelid={this.state.requestlist.hotelID}
                  entryType={
                    this.props.isFromRepeating ? "Transferrepeat" : "Transfer"
                  }
                  uniqueNo={
                    this.state.formData.actionType === "copy"
                      ? 0
                      : this.state.transferLogID
                  }
                  precommentlist={this.state.htmlcomment}
                  parentScrollMethod={this.scrollToBottom}
                  updatedCommentItem={this.updatedCommentItem}
                />
              </div>
            )}

            <div
              className={
                this.state.isStateChanged || isBankSyncTransfer
                  ? "viewer-panel footer-section"
                  : "viewer-panel footer-section isHide"
              }
            >
              <div
                className={
                  this.state.isError === "NotEdit" ? "disabled-area" : ""
                }
              >
                <div className="d-flex align-items-center justify-content-end height-72">
                  {!isBankSyncTransfer && this.props.uniqueNo === 0 && (
                    <Form.Group controlId="formBasicCheckbox">
                      <Form.Check
                        type="checkbox"
                        label="Create Another"
                        checked={this.state.createOther}
                        onChange={(event: any) =>
                          this.handleChange(event, "createOther")
                        }
                        custom
                      />
                    </Form.Group>
                  )}
                  <Button
                    variant="primary"
                    type="button"
                    className="space btn btn-primary btn-discard"
                    onClick={this.closeSlideOut}
                  >
                    Cancel
                  </Button>
                  {(this.state.isStateChanged || isBankSyncTransfer) && (
                    <Button
                      variant="primary"
                      type="button"
                      disabled={saveBtnDisable}
                      onClick={this.saveDeposit}
                    >
                      Save Transfer
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </Container>
          {this.state.isSpinner && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}
          {this.state.isDisable && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}

          <Modal
            backdrop="static"
            keyboard={false}
            show={this.state.voidModal}
            className="transferVoidModal"
            onHide={this.voidModalHide}
          >
            <Modal.Header closeButton>
              <Modal.Title>Void Entry</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="textmsgV">
                The offset for the selected Check would be created under
              </p>
              <p className="labelTextV">Original Transaction</p>
              <div className="OldTrans">
                <Row>
                  <Col sm="6">
                    <Form.Group>
                      <Form.Label>Check Date</Form.Label>
                      <Form.Control
                        id="checkdate"
                        value={this.state.formData.eCheckDate}
                        disabled={true}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm="6">
                    <Form.Group>
                      <Form.Label>Accounting Period</Form.Label>
                      <Form.Control
                        id="state"
                        value={this.state.formData.AccPer}
                        disabled={true}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <p className="labelTextV">Void Transaction</p>
              <div className="OldTrans">
                <Row>
                  <Col sm="6">
                    <Form.Group>
                      <Form.Label>Date</Form.Label>
                      <div className="date-picker calender-picker">
                        <DatePicker
                          tabIndex={this.state.tabEnable}
                          className="form-control voiddatePicker"
                          placeholderText={"MM/DD/YY"}
                          dateFormat="MM/dd/yy"
                          selected={
                            this.state.voidData.Date === null
                              ? ""
                              : new Date(this.state.voidData.Date)
                          }
                          onChange={(event: any) =>
                            this.handleChange(event, "VoidDate")
                          }
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col sm="6">
                    <Form.Group>
                      <Form.Label>Accounting Period</Form.Label>
                      <div className="rm-bottom-margin form-group">
                        <div className="single-select">
                          <SingleDropdownListWithoutSearch
                            id={"accountingPeriod"}
                            key={Math.floor(Math.random() * 90 + 10)}
                            itemList={this.state.voidAccPerList}
                            handleSelectedItem={(event: any) =>
                              this.handleSelectedData(event, "voidAccPer")
                            }
                            defaultItem={this.state.voidData.AccPer}
                            defaultText={"Accouting Period"}
                            defaultName={this.state.voidData.AccPer}
                            controlID="6"
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>Reason</Form.Label>
                      <Form.Control
                        id="VoidReason"
                        as="textarea"
                        value={this.state.voidData.reason}
                        placeholder="Enter reason"
                        onChange={(e) => {
                          this.handleChange(e, "voidreason");
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn-outline-primary"
                disabled={this.state.isVoidStart}
                onClick={this.voidModalHide}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                disabled={this.state.isVoidStart}
                onClick={this.createVoidEntry}
              >
                {this.state.isVoidStart && (
                  <>
                    <Spinner size="sm" animation="border" />{" "}
                  </>
                )}{" "}
                Void
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            backdrop="static"
            keyboard={false}
            show={this.state.alertModalshow}
            className="transferModal"
            onHide={this.alertModalHide}
          >
            <Modal.Header closeButton>
              <Modal.Title>Transfer Entry</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                Date entered is a future date. Press Cancel to Change, OK to
                Continue.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button className="btnCancel" onClick={this.alertModalHide}>
                Cancel
              </Button>
              <Button variant="primary" onClick={this.saveDepositeEntry}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }

  onSelectRepeatType = (item) => {
    this.setState({ selectedRepeatType: item.name, isStateChanged: true });
  }

  createVoidEntry = () => {
    let checkDate = this.state.formData.eCheckDate;
    let currentDate = new Date(checkDate);
    let lastDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    if (new Date(this.state.voidData.Date) > lastDay) {
      Utils.toastError("Entry can not void in future date.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "SaveTransfer",
      });
      return;
    }
    const isCurrentPerActiveFound = this.state.voidAccPerList.some(
      (item) => item.name === this.state.voidData.AccPer
    );

    if (!isCurrentPerActiveFound) {
      Utils.toastError(
        "Transaction date should be in an active accounting period.",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        }
      );
      return;
    }

    this.setState({ isVoidStart: true });
    let request: any = {};
    request.uniqueno = this.state.formData.UniqueNo;
    request.Fyear = "";
    request.HID = this.state.formData.BackHID;
    request.Etype = "Transfer";
    request.Period = this.state.voidData.AccPer;
    request.VoidDate = moment(this.state.voidData.Date).format("DD-MMM-YYYY");
    request.VoidReason = this.state.voidData.reason;
    registersevice
      .VoidTranactionEntry(request)
      .then(async (result: any | null) => {
        if (result?.result?.result?.toLowerCase() === "success") {
          toast.success("Entry void successfully.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "SaveTransfer",
          });
          setTimeout(() => {
            this.setState({ isChangeTr: true, isVoidStart: false });
            this.closeSlideOut();
          }, 1500);
        } else if (result?.result?.toLowerCase() === "accperinact") {
          Utils.toastError(
            "Transaction date should be in an active accounting period.",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "SaveTransfer",
            }
          );
          this.setState({ isVoidStart: false });
        } else {
          Utils.toastError(result.result, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "SaveTransfer",
          });
          this.setState({ isVoidStart: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ hasDeleteAccess: false, isVoidStart: false });
        reject();
      });
  };

  constructor(props: any) {
    super(props);
    this.ChildComment = React.createRef();
    this.parentScroll = React.createRef();

    this.footerchk = React.createRef();
    this.scrollheight = React.createRef();

    this.state = {
      accountingPeriodActive: false,
      isError: "",
      transferLogID: 0,
      htmlcomment: [],
      isFromAccountChange: false,
      isComment: false,
      selectdefaultperiod: "Accounting Period",
      isStateChanged: false,
      AccPerList: [],
      voidAccPerList: [],
      AccPerToList: [],
      hidListCount: [],
      RepType: false,
      hasOP: false,
      newSelectedfiles: [],
      logInUserID: "",
      accountFromNamelist: [],
      accountFromNamelist1: [],
      accountToNamelist: [],
      accountToNamelist1: [],
      createOther: false,
      tabEnable: 0,
      savedfiles: [],
      files: [],
      spliHIDToList: [],
      hasEditPermission: "No",
      moreActionFileUpload: [{ name: "Delete", eventKey: "delete" }],
      moreActionFileUpload1: [
        { name: "Download", eventKey: "download" },
        { name: "Delete", eventKey: "deleteFile" },
      ],
      moreAction: [
        { name: "Repeating(0)", eventKey: "repeating" },
        { name: "Repeating(0)", eventKey: "repeating" },
        { name: "Change Log", eventKey: "changeLog" },
        { name: "Delete", eventKey: "deleteTEntry" },
        { name: "Copy", eventKey: "copy" },
      ],
      hasDeletePermission: false,
      hasDeleteAccess: false,
      requestlist: {
        hotelID: 0,
        oprID: -1,
        etype: "Transfer",
        vid: 0,
        recordCount: 5,
      },
      BackHIDNM: "Choose an EHID",
      fAccBalData: [],
      fAccBalShow: false,
      COAList: [],
      faccountName: "Select Account",
      fAccBal: 0.0,
      COAFromName: [],
      HIDToNM: "Choose an EHID",
      taccountName: "Select Account",
      COAToName: [],
      isRowClick: false,
      isCheckEntry: false,
      hasReimbursement: false,
      hasCheckEntry: false,
      hasRecouncil: false,
      noEditPermission: false,
      isGLPermission: false,
      alertModalshow: false,
      glArray: [],
      dateArray: [],
      hasActiveMonth1: [],
      hasActiveMonth2: [],
      isChangeTr: false,
      isDisable: false,
      voidData: {
        Date: null,
        AccPer: "Accounting Period",
        reason: "",
        isVoid: false,
        voidShow: "NoShow",
        isVoidPermSearch: false,
        accountStatus: "Inactive",
        voidPermission: "No",
        accountStatusTo: "Inactive",
      },
      isVoidStart: false,
      formData: {
        oldUniqueNo: 0,
        UniqueNo: "",
        TenantID: "",
        Date: null,
        AccPer: "Accounting Period",
        BackHID: "",
        HIDTo: "",
        TypeFrom: "",
        OldTypeFrom: "",
        TypeTo: "",
        OprIdFrom: "",
        OprIdTo: "",
        COAFrom: "",
        COATo: "",
        TransTotal: "",
        TransTotalHeader: "",
        RepUniqueNo: 0,
        Description: "",
        RepType: "No",
        StartDate: "",
        EndDate: "",
        PaymentMethod: "Manual ACH",
        actionType: "",
        iscopyAttachment: "",
        transferLogID: 0,
        isCOAPer1: "Yes",
        isCOAPer2: "Yes",
        COANameFrom: "",
        COANameTo: "",
        eCheckNo: "",
        eCheckDate: "",
        TempUniqueNo: "",
        repeatType: "",
      },
      showChangeLogModal: false,
      fileSize: 5242880,
      isCopyEntry: false,
      showBadge: false,
      oldTranDate: "",

      isOpenViewer: false,
      defaultView: "doc-view",
      isMapped: "No",
      isMappedShow: false,
      chkIds: [],
      currentZoom: 1.0,
      selectedChk: [],
      isAttachmentLoading: false,
      tempUniqueNo: "",
      slideEntryType: "oldEntry",
      isCopyHasAttachment: false,
      currentScreenTop: 0,
      isTrEntryPaid: false,
      isFreshEntry: false,
      repeatList: [{id: 1, name: 'Monthly', displayName: "Monthly",}, {id: 2, name: 'Every 2 Weeks', displayName: "Every 2 Weeks"}, {id: 3, name: 'Weekly', displayName: "Weekly"}],
      selectedRepeatType: "Monthly",
    };
    this.closeSlideOut = this.closeSlideOut.bind(this);
    this.hideSlideOut = this.hideSlideOut.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.updatedCommentItem = this.updatedCommentItem.bind(this);
  }
  componentDidMount() {
    this.reCallApis();
  }
  scrollToBottom = () => {
    this.parentScroll.current.scrollTo({
      top: this.parentScroll.current.scrollHeight,
      behavior: "smooth",
    });
  };

  updatedCommentItem = () => {
    let updatedItem: any = {};
    this.setState({ isChangeTr: true });
    updatedItem.transcationDate = this.state.formData.Date;
    updatedItem.vendorName = "";
    updatedItem.amountTotal = this.state.formData.TransTotal;
    return updatedItem;
  };

  isValidateModelPoupTab = () => {
    confirmAlert({
      title: "Unsaved confirmation",
      message:
        "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.closeSlideOut(),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  onMoreActionChange = (eventKey) => {
    if (eventKey === "changeLog") {
      this.showHideChangeLogModal();
    }

    if (eventKey === "copy") {
      if (this.state.savedfiles.length > 0) {
        confirmAlert({
          title: "Copy Transaction",
          message:
            "Do you want to copy over the attachments to the new transaction?",
          buttons: [
            {
              label: "Yes",
              onClick: () => this.CopyTransaction("Yes"),
            },
            {
              label: "No",
              onClick: () => this.CopyTransaction("No"),
            },
          ],
          overlayClassName: "copy-trancsation-alert",
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      } else {
        this.CopyTransaction("No");
      }
    }
    if (eventKey === "void") {
      confirmAlert({
        title: "Void entry",
        message:
          "Please note, When Voided, A duplicate entry will be created under the same COA's but with opposite sign amount. The duplicate entry would be posted in selected active accounting period. Both the entries would be reflected in Operating Account.",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              this.setState({ voidModal: true });
            },
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
      });
    }
  };

  CopyTransaction(type: any) {
    let AccPerList: any = [];
    AccPerList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.AccPerList))
    );
    let formData = { ...this.state.formData };
    let { COAFromName, COAToName } = this.state;
    formData.oldUniqueNo = formData.UniqueNo;
    formData.UniqueNo = 0;
    formData.actionType = "copy";
    formData.Date = null;
    formData.TransTotal = "";
    formData.TransTotalHeader = "";
    formData.AccPer = this.state.selectdefaultperiod;
    if (formData.isCOAPer1 === "No") {
      formData.COANameFrom = "";
      formData.COAFrom = "";
      COAFromName = [];
    }
    if (formData.isCOAPer2 === "No") {
      formData.COANameTo = "";
      formData.COATo = "";
      COAToName = [];
    }
    formData.isCOAPer1 = "Yes";
    formData.isCOAPer2 = "Yes";
    if (type === "Yes") {
      formData.iscopyAttachment = "Yes";
      this.setState({ isCopyHasAttachment: true }, () => {
        this.GetTempUploadTransNo();
      });
    } else {
      formData.iscopyAttachment = "No";
      this.setState({ files: [], savedfiles: [], isOpenViewer: false }, () => {
        this.GetTempUploadTransNo();
      });
    }
    toast.success(
      "The Transaction has been copied and Ready to make the changes.",
      {
        position: toast.POSITION.BOTTOM_RIGHT,
      }
    );
    this.setState(
      {
        AccPerList: [],
        isStateChanged: true,
        defaultPeriod: this.state.selectdefaultperiod,
        isComment: false,
        htmlcomment: [],
        hasRecouncil: false,
      },
      () => {
        this.setState(
          {
            isComment: true,
            AccPerList,
            formData,
            isCopyEntry: true,
            hasCheckEntry: false,
            showBadge: false,
            hasEditPermission: "Yes",
            hasReimbursement: false,
            noEditPermission: false,
            isError: "Edit",
            isCheckEntry: false,
            isTrEntryPaid: false,
            COAFromName,
            COAToName,
          },
          () => {
            let requestlist = { ...this.state.requestlist };
            let defaulteType = "Transfer";
            requestlist.hotelID = this.state.requestlist.hotelID;
            requestlist.OprIdFrom = this.props.accDetails.oprID;
            requestlist.etype = defaulteType;
            this.GetAccountingPeriodCopy(requestlist);
          }
        );
      }
    );
  }

  SaveCopyTempWithFile(files: any) {
    this.setState({ currentScreenTop: 0 });
    let { formData } = this.state;
    let request: any = {};
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage?.tenantID);
    request.TenantID = tenantID;
    request.actionType = "Copy";
    request.UniqueNo = formData.uniqueno;
    request.iscopyAttachment = "Yes";
    request.TempUniqueNo = this.state.tempUniqueNo;
    request.oldUniqueNo = formData.oldUniqueNo;
    request.TypeFrom = formData.TypeFrom;
    request.OldTypeFrom = formData.OldTypeFrom;
    registersevice
      .SaveTempWithFile(request, files)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            this.setState({ isCopyHasAttachment: false }, () => {
              this.getUploadedFileList();
            });
          } else {
            Utils.toastError("Failed to upload attachment.", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            this.setState(
              { isDisabled: false, isCopyHasAttachment: false },
              () => {
                this.getUploadedFileList();
              }
            );
          }
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  showHideChangeLogModal = () => {
    this.setState({
      showChangeLogModal: !this.state.showChangeLogModal,
    });
  };

  reCallApis = () => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage?.tenantID);
    let requestlist = { ...this.state.requestlist };
    let formData = { ...this.state.formData };
    let defaulteType = "Transfer";
    requestlist.hotelID = this.props.hidValue;
    requestlist.oprID = this.props.accDetails.oprID;
    requestlist.OprIdFrom = this.props.accDetails.oprID;
    requestlist.etype = defaulteType;
    formData.UniqueNo = this.props.uniqueNo;
    formData.BackHID = this.props.hidValue;
    let BackHIDNM = this.props.hotelName;
    formData.TenantID = tenantID;
    let glArray = this.props.transferRequest.glArray;
    this.setState({
      formData,
      requestlist,
      BackHIDNM,
      glArray,
      isFreshEntry: this.props.uniqueNo === 0,
    });
    let reqEditlist: any = {};
    let isAccType = (this.props.transferRequest?.acctType);
    let isConditionPM = (isAccType === "P" ? "Payroll" : isAccType === "M" && "Miscellaneous")
    let acctType = (isAccType === "O" ? "Operating" : isConditionPM);
    reqEditlist.UniqueNo = Number(this.props.uniqueNo);
    reqEditlist.TypeFrom = acctType;
    reqEditlist.OldTypeFrom = acctType;
    if (this.props.uniqueNo > 0 && this.props.isFromRepeating) {
      reqEditlist.RepeatType = "Yes";
      this.setState({ RepType: true });
      this.GetRepeatTransferEntry(reqEditlist);
    } else if (this.props.uniqueNo > 0) {
      reqEditlist.RepeatType = "No";
      this.GetTransferEntry(reqEditlist);
    }
    if (this.props.uniqueNo === 0) {
      this.setState({ hasEditPermission: "Yes" });
      this.loadHotelsDetails();
      this.GetTempUploadTransNo();
    }
    this.getFileSize();
  };

  GetTempUploadTransNo = () => {
    let request: any = {};
    let accMod = (this.props.transferRequest.acctType === "" ? this.props.accDetails.acctType : this.props.transferRequest.acctType);
    let acctType: any = "";
    switch (accMod) {
      case "O":
        acctType = "Operating";
        break;
      case "P":
        acctType = "Payroll";
        break;
      case "M":
        acctType = "Miscellaneous";
        break;
      default:
        acctType = "";
        break;
    }
    request.EType = acctType;
    registersevice
      .GetTempUploadTransNo(request)
      .then(async (result: any) => {
        if (result !== null) {
          this.setState(
            {
              tempUniqueNo: result.result,
              slideEntryType: "newEntry",
              currentScreenTop: 0,
            },
            () => {
              if (this.state.isCopyHasAttachment) {
                this.SaveCopyTempWithFile([]);
              }
            }
          );
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, { position: toast.POSITION.BOTTOM_RIGHT });
        setTimeout(() => {
          this.closeSlideOut();
        }, 1500);
        reject();
      });
  };

  rightArrow = () => {
    return (
      <svg
        stroke="currentColor"
        fill="#1d1e20"
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="3em"
        width="3em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"></path>
      </svg>
    );
  };

  actType = (e) => {
    let acctType = "";
    e.acctType === "O"
      ? (acctType = "Operating")
      : e.acctType === "P"
        ? (acctType = "Payroll")
        : e.acctType === "M" && (acctType = "Miscellaneous");
    return acctType;
  };

  actTypeName = (e) => {
    let acctType = "";
    e === "O"
      ? (acctType = "Operating")
      : e === "P"
        ? (acctType = "Payroll")
        : e === "M" && (acctType = "Miscellaneous");
    return acctType;
  };

  newAccPer(accPeriod: any) {
    let accPer: any = new Date(new Date(accPeriod)).toLocaleDateString();
    let month: any =
      accPer.split("/")[0] < 10 && accPer.split("/")[0].length < 2
        ? "0" + accPer.split("/")[0]
        : accPer.split("/")[0];
    let day: any = "01";
    let Year: any = accPer.split("/")[2].substr(2);
    return `${month}/${day}/${Year}`;
  }

  GetTransferEntry = (reqEditlist) => {
    let formData = { ...this.state.formData };
    let voidData = { ...this.state.voidData };
    let {
      hasRecouncil,
      noEditPermission,
      isGLPermission,
      hasCheckEntry,
      isCheckEntry,
      isTrEntryPaid,
      accountingPeriodActive,
    } = this.state;
    registersevice
      .GetTransferEntry(reqEditlist)
      .then(async (result: any) => {
        if (result !== null) {
          if (result.transferData !== null) {
            let hasReimbursement;
            let apiTransferData: any = result.transferData;
            let apiUploadFileList: any = result.uploadFileList;
            if (apiTransferData !== null && apiUploadFileList !== null) {
              let transferData = result.transferData;
              let isError = transferData.isError;
              if (isError === "Yes") {
                window.location.href = "/unauthorize-access?Error=NotFound";
              } else {
                let uploadFiles = result.uploadFileList;
                for (let i = 0; i < uploadFiles.length; i++) {
                  this["myRef" + i] = React.createRef();
                }
                isTrEntryPaid =
                  transferData.isPaid.toString().toLocaleLowerCase() ===
                  "paid" &&
                  transferData.paymentMethod.toString().toLowerCase() !== "ach";
                hasReimbursement =
                  transferData.transferSource.toString().toLowerCase() ===
                  "reimbursement";
                accountingPeriodActive =
                  transferData.accPerStatus.toString().toLowerCase() ===
                  "active";
                formData.AccPer =
                  new Date(transferData.accPer).toString() === "Invalid Date"
                    ? ""
                    : moment(transferData.accPer).format("MM/DD/YY");
                voidData.AccPer =
                  new Date(transferData.accPer).toString() === "Invalid Date"
                    ? ""
                    : moment(transferData.accPer).format("MM/DD/YY");
                formData.BackHID = transferData.backHID;
                formData.COAFrom = transferData.coaFrom;
                formData.COATo = transferData.coaTo;
                formData.Date = transferData.date;
                voidData.Date = transferData.date;
                voidData.voidShow = transferData.isVoidShow;
                voidData.isVoidPermSearch = transferData.isVoidPermSearch;
                voidData.accountStatus = transferData.accountStatus;
                voidData.accountStatusTo = transferData.accountStatusTo;
                voidData.isVoid = transferData.isVoid;
                voidData.voidPermission = transferData.voidPermission;
                voidData.fromPer = transferData.fromPer;
                formData.Description = transferData.description;
                formData.EndDate = transferData.endDate;
                formData.HIDTo = transferData.hidTo;
                formData.OprIdFrom = transferData.oprIdFrom;
                formData.OprIdTo = transferData.oprIdTo;
                transferData.paymentMethod =
                  transferData.paymentMethod.toString().toLowerCase() === "ach"
                    ? "Manual ACH"
                    : transferData.paymentMethod;
                formData.PaymentMethod =
                  transferData.paymentMethod !== null &&
                    transferData.paymentMethod === ""
                    ? "Manual ACH"
                    : transferData.paymentMethod;
                formData.RepType = transferData.repType;
                formData.RepUniqueNo = transferData.repUniqueNo;
                formData.StartDate = transferData.startDate;
                formData.TenantID = transferData.tenantID;
                formData.TransTotal = Utils.currencyFormatWithOutdoller(
                  transferData.transTotal
                );
                formData.TransTotalHeader = transferData.transTotal;
                formData.TypeFrom = transferData.typeFrom;
                formData.OldTypeFrom = transferData.typeFrom;
                formData.TypeTo = transferData.typeTo;
                formData.UniqueNo = transferData.uniqueNo;
                formData.transferLogID = transferData.iF_Record;
                hasRecouncil = transferData.isReconcile;
                formData.isCOAPer1 = transferData.isCOAPer1;
                formData.isCOAPer2 = transferData.isCOAPer2;
                formData.COANameFrom =
                  transferData.coaFrom + " " + transferData.coaNameFrom;
                formData.COANameTo =
                  transferData.coaTo + " " + transferData.coaNameTo;
                formData.eCheckNo = transferData.eCkNo;
                formData.eCheckDate = transferData.eCkDate;
                noEditPermission =
                  transferData.isEditPer.toString().toLocaleLowerCase() ===
                    "Yes".toLocaleLowerCase()
                    ? false
                    : true;

                let todaysDate = new Date();
                todaysDate.setHours(0, 0, 0, 0);
                if (new Date(transferData.date) < todaysDate && transferData.paymentMethod !== null && transferData.paymentMethod.toString().toLocaleLowerCase() === "check") {
                  // isCheckEntry = true;
                } else {
                  isCheckEntry = false;
                }

                hasCheckEntry =
                  transferData.paymentMethod !== null &&
                  transferData.paymentMethod.toString().toLocaleLowerCase() ===
                  "check" &&
                  transferData.eCkNo !== "";
                let selectedAcc = transferData.typeFrom.charAt(0);
                let glArray =
                  transferData.isGLView !== null
                    ? transferData.isGLView.split(",")
                    : "";
                let hasGLVal: any = [];
                glArray.forEach((item) => {
                  if (item === selectedAcc) {
                    hasGLVal.push(item);
                  }
                });
                hasGLVal.length > 0
                  ? (isGLPermission = true)
                  : (isGLPermission = false);

                let requestlist = { ...this.state.requestlist };
                let defaulteType = "Transfer";
                requestlist.hotelID = transferData.backHID;
                requestlist.OprIdFrom = transferData.oprIdFrom;
                requestlist.etype = defaulteType;
                let fileList: any = [];
                uploadFiles.forEach((item) => {
                  item.newname = item.name.toString().toLowerCase();
                  fileList.push(item);
                });
                fileList = _.sortBy(fileList, "newname");
                this.setState(
                  {
                    isComment: true,
                    transferLogID: transferData.iF_Record,
                    isError: isError,
                    requestlist,
                    BackHIDNM1: transferData.backLettercode,
                    hasReimbursement: hasReimbursement,
                    savedfiles: fileList,
                    noEditPermission,
                    isGLPermission,
                    hasCheckEntry,
                    formData,
                    glArray,
                    hasRecouncil,
                    isRowClick: true,
                    showBadge: true,
                    isCheckEntry,
                    oldTranDate: transferData.date,
                    isOpenViewer: fileList.length > 0,
                    voidData,
                    isTrEntryPaid,
                    accountingPeriodActive,
                  },
                  () => {
                    let reqTo: any = {};
                    let reqFrom: any = {};
                    let clreqFrom: any = {};
                    let _reqFrom: any = {};

                    reqTo.hotelID = formData.HIDTo;
                    _reqFrom.hotelID = formData.BackHID;
                    _reqFrom.oprID = formData.OprIdFrom;
                    reqFrom.hotelID = formData.BackHID;
                    clreqFrom.hotelID = formData.BackHID;
                    clreqFrom.ForTransferPage = 1;
                    let requestlist = { ...this.state.requestlist };
                    requestlist.hotelID = formData.BackHID;
                    requestlist.OprIdFrom = formData.OprIdFrom;
                    requestlist.etype = "Transfer";
                    let requestlist2 = { ...this.state.requestlist };
                    requestlist2.hotelID = formData.HIDTo;
                    let checkOprFrom = formData.OprIdFrom === "" ? this.props?.accDetails?.oprID : formData.OprIdFrom;
                    let checkOprto = formData.OprIdTo === "" ? this.props?.accDetails?.oprID : formData.OprIdTo;
                    requestlist2.OprIdFrom = (this.state.faccountName === "Select Account" ? checkOprto : checkOprFrom);
                    requestlist2.etype = "Transfer";

                    this.getWebTimeClockManagerPermission();
                    this.getAccountToNames(reqTo);
                    this.getAccountFromBal(_reqFrom);
                    this.getAccountFromNames(reqFrom);
                    this.transactionFromChartList(clreqFrom);
                    this.GetAccountingPeriod(requestlist, "");
                    this.GetAccountingToPeriod(requestlist2);
                    this.loadHotelsDetails();
                    this.GetTransactionComment();
                    this.getUploadedFileList();
                  }
                );
              }
            } else {
              Utils.toastError("Something went wrong.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveTransfer",
              });
              setTimeout(() => {
                this.closeSlideOut();
              }, 2000);
            }
          } else {
            window.location.href = "/unauthorize-access?Error=NotFound";
          }
        } else {
          window.location.href = "/unauthorize-access?Error=NotFound";
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        setTimeout(() => {
          this.closeSlideOut();
        }, 2000);
        reject();
      });
  };

  getUploadedFileList = () => {
    let requestlist: any = {};
    let accMod = (this.props.transferRequest.acctType === "" ? this.props.accDetails.acctType : this.props.transferRequest.acctType);
    let acctType =
      accMod === "O"
        ? "Operating"
        : accMod === "P"
          ? "Payroll"
          : accMod === "M" && "Miscellaneous";
    requestlist.uniqueNo =
      this.state.slideEntryType === "newEntry"
        ? this.state.tempUniqueNo
        : this.props.uniqueNo;
    requestlist.checkNo = "";
    requestlist.series = "A";
    requestlist.etype =
      this.state.slideEntryType === "newEntry" ? "TempUploadFiles" : acctType;

    this.setState({ isAttachmentLoading: true });
    registersevice
      .GetUploadFileWithFileCode(requestlist)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            this["myRef" + i] = React.createRef();
          }
          let filelist: any[] = [];
          result.forEach((element, i) => {
            element.fileCode =
              "data:application/pdf;base64," + element.fileCode;
            element.fileName = element.name;
            element.newname = element.name.toString().toLowerCase();
            filelist.push(element);
          });
          filelist = _.sortBy(filelist, "newname");
          this.setState(
            (prevState) => ({
              savedfiles: filelist,
              isAttachmentLoading: false,
              isOpenViewer: prevState.isOpenViewer,
              newSelectedfiles: [],
              files: [],
            }),
            () => {
              setTimeout(() => {
                this.scrollheight.current?.getElement().scrollTo({
                  top: Number(this.state.currentScreenTop),
                  behavior: "smooth",
                });
              }, 500);
            }
          );
        } else {
          this.setState({
            isOpenViewer: false,
            savedfiles: [],
            newSelectedfiles: [],
            files: [],
            bulkSelect: false,
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  GetRepeatTransferEntry = (reqEditlist) => {
    let formData = { ...this.state.formData };
    registersevice
      .GetRepeatTransferEntry(reqEditlist)
      .then(async (result: any) => {
        if (result !== null) {
          if (result.transferData !== null) {
            console.log(result);
            let hasReimbursement;
            let apiTransferData: any = result.transferData;
            if (apiTransferData !== null) {
              let transferData = result.transferData;

              let isError = transferData.isError;
              if (isError === "Yes") {
                window.location.href = "/unauthorize-access?Error=NotFound";
              } else {
                let uploadFiles = [];
                hasReimbursement =
                  transferData.transferSource.toString().toLowerCase() ===
                  "reimbursement";
                formData.AccPer =
                  new Date(transferData.accPer).toString() === "Invalid Date"
                    ? ""
                    : moment(transferData.accPer).format("MM/DD/YY");
                formData.BackHID = transferData.backHID;
                formData.COAFrom = transferData.coaFrom;
                formData.COATo = transferData.coaTo;
                formData.Date = transferData.date;
                formData.Description = transferData.description;
                formData.EndDate = transferData.endDate;
                formData.HIDTo = transferData.hidTo;
                formData.OprIdFrom = transferData.oprIdFrom;
                formData.OprIdTo = transferData.oprIdTo;
                transferData.paymentMethod =
                  transferData.paymentMethod.toString().toLowerCase() === "ach"
                    ? "Manual ACH"
                    : transferData.paymentMethod;
                formData.PaymentMethod =
                  transferData.paymentMethod === ""
                    ? "Manual ACH"
                    : transferData.paymentMethod;
                formData.RepType = transferData.repType;
                formData.RepUniqueNo = transferData.repUniqueNo;
                formData.StartDate = transferData.startDate;
                formData.TenantID = transferData.tenantID;
                formData.TransTotal = Utils.currencyFormatWithOutdoller(
                  transferData.transTotal
                );
                formData.TransTotalHeader = transferData.transTotal;
                formData.TypeFrom = transferData.typeFrom;
                formData.OldTypeFrom = transferData.typeFrom;
                formData.TypeTo = transferData.typeTo;
                formData.UniqueNo = transferData.uniqueNo;
                formData.transferLogID = transferData.iF_Record;
                let requestlist = { ...this.state.requestlist };
                let defaulteType = "Transfer";
                requestlist.hotelID = transferData.backHID;
                requestlist.OprIdFrom = transferData.oprIdFrom;
                requestlist.etype = defaulteType;
                formData.isCOAPer1 = transferData.isCOAPer1;
                formData.isCOAPer2 = transferData.isCOAPer2;
                formData.COANameFrom = transferData.coaFrom + " " + transferData.coaNameFrom;
                formData.COANameTo = transferData.coaTo + " " + transferData.coaNameTo;
                formData.repeatType = transferData.repeatType;
                this.setState(
                  {
                    selectedRepeatType: transferData.repeatType,
                    isComment: true,
                    transferLogID: transferData.iF_Record,
                    isError: isError,
                    requestlist,
                    BackHIDNM1: transferData.backLettercode,
                    hasReimbursement: hasReimbursement,
                    savedfiles: uploadFiles,
                    formData,
                    isRowClick: true,
                    oldTranDate: transferData.date,
                  },
                  () => {
                    let reqTo: any = {};
                    let reqFrom: any = {};
                    let clreqFrom: any = {};
                    let _reqFrom: any = {};

                    reqTo.hotelID = formData.HIDTo;
                    _reqFrom.hotelID = formData.BackHID;
                    _reqFrom.oprID = formData.OprIdFrom;
                    reqFrom.hotelID = formData.BackHID;
                    clreqFrom.hotelID = formData.BackHID;
                    clreqFrom.ForTransferPage = 1;
                    let requestlist = { ...this.state.requestlist };
                    requestlist.hotelID = formData.BackHID;
                    requestlist.OprIdFrom = formData.OprIdFrom;
                    requestlist.etype = "Transfer";
                    let requestlist2 = { ...this.state.requestlist };
                    requestlist2.hotelID = formData.HIDTo;
                    let checkOprFrom = formData.OprIdFrom === "" ? this.props?.accDetails?.oprID : formData.OprIdFrom;
                    let checkOprto = formData.OprIdTo === "" ? this.props?.accDetails?.oprID : formData.OprIdTo;
                    requestlist2.OprIdFrom = (this.state.faccountName === "Select Account" ? checkOprto : checkOprFrom);
                    requestlist2.etype = "Transfer";

                    this.getWebTimeClockManagerPermission();
                    this.getAccountToNames(reqTo);
                    this.getAccountFromBal(_reqFrom);
                    this.getAccountFromNames(reqFrom);
                    this.transactionFromChartList(clreqFrom);
                    this.GetAccountingPeriod(requestlist, "");
                    this.GetAccountingToPeriod(requestlist2);
                    this.loadHotelsDetails();
                    this.GetTransactionComment();
                  }
                );
              }
            } else {
              Utils.toastError("Something went wrong.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveTransfer",
              });
              setTimeout(() => {
                this.closeSlideOut();
              }, 2000);
            }
          } else {
            window.location.href = "/unauthorize-access?Error=NotFound";
          }
        } else {
          window.location.href = "/unauthorize-access?Error=NotFound";
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        setTimeout(() => {
          this.closeSlideOut();
        }, 2000);
        reject();
      });
  };

  GetTransactionComment = () => {
    let commentRequest: any = {};
    commentRequest.uniqueNo = this.state.transferLogID;
    commentRequest.etype = this.props.isFromRepeating
      ? "Transferrepeat"
      : "Transfer";
    registersevice
      .GetTransactionComment(commentRequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ htmlcomment: [], isComment: false }, () => {
            this.setState({ htmlcomment: result, isComment: true });
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  hasEditAccess = (e) => {
    if (
      this.state.hasEditPermission === "No" ||
      this.state.hasReimbursement ||
      this.state.hasCheckEntry ||
      this.state.hasRecouncil ||
      this.state.noEditPermission ||
      this.state.AccPerList.length === 0 ||
      this.state.isCheckEntry
    ) {
      if (e.keyCode === 9) e.preventDefault();
    }
  };

  loadHotelsDetails() {
    let formData = { ...this.state.formData };
    Hotel.HotelListForTransfer("Accounting")
      .then(async (result: any | null) => {
        if (result != null) {
          if (this.state.isRowClick) {
            let hasFromHID: any = result.filter(
              (item) => item.hotelID === Number(formData.BackHID)
            );
            let hasToHID: any = result.filter(
              (item) => item.hotelID === Number(formData.HIDTo)
            );
            formData.BackHID =
              hasFromHID.length > 0 ? hasFromHID[0].hotelID : -1;
            this.setState({
              HIDToNM:
                hasToHID.length > 0 ? hasToHID[0].lettercode : "Choose an EHID",
              BackHIDNM:
                hasFromHID.length > 0
                  ? hasFromHID[0].lettercode
                  : "Choose an EHID",
              formData,
            });
          } else if (this.state.isFreshEntry) {
            let isHid: any = result.filter(
              (item) => item.hotelID === Number(this.props?.hidValue)
            );
            if (isHid.length > 0) {
              formData.BackHID = isHid.length > 0 ? isHid[0].hotelID : -1;
              formData.HIDTo = isHid.length > 0 ? isHid[0].hotelID : -1;
              this.setState(
                {
                  HIDToNM:
                    isHid.length > 0 ? isHid[0].lettercode : "Choose an EHID",
                  BackHIDNM:
                    isHid.length > 0 ? isHid[0].lettercode : "Choose an EHID",
                  formData,
                  fAccBalShow: true,
                  // isStateChanged: true,
                },
                () => {
                  let request: any = {};
                  let reqBal: any = {};
                  request.hotelID = isHid[0].hotelID;
                  reqBal.hotelID = isHid[0].hotelID;
                  reqBal.oprID = Number(this.props?.accDetails?.oprID);
                  this.getAccountFromNames(request);
                  this.getAccountToNames(request);
                  this.getAccountFromBal(reqBal);
                }
              );
            }
          }
          let _result = result.map((item: any, id: any) => {
            return {
              name: item.lettercode,
              id: item.hotelID,
              ehidName: item.ehidName,
              hotelID: item.hotelID,
              hotelName: item.hotelName,
              hotelType: item.hotelType,
              lettercode: item.lettercode,
              tenantID: item.tenantID,
              timeZone: item.timeZone,
            };
          });
          this.setState({
            hidListCount: _result,
          });
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        reject();
      });
  }

  closeSlideOut() {
    this.props.hideTrSlideOut(this.state.isChangeTr);
    this.setState({ isRowClick: false, hasReimbursement: false });
  }

  hideSlideOut() {
    if (this.state.isStateChanged) {
      this.isValidateModelPoupTab();
    } else {
      this.setState({ isStateChanged: false }, () => {
        this.props.hideTrSlideOut(this.state.isChangeTr);
        this.setState({ isRowClick: false, hasReimbursement: false });
      });
    }
  }
  GetAccountingPeriodCopy = (requestlist: any) => {
    let accPeriod: any = [];
    registersevice
      .GetAccountingPeriod(requestlist)
      .then(async (result: any | null) => {
        if (this.state.formData.actionType === "copy") {
          if (result.length > 0) {
            result.forEach((element) => {
              let item: any = {};
              item.id = element.accperiod;
              item.name = element.accperiod;
              item.defaultPeriod = element.defaultPeriod;
              accPeriod.push(item);
            });
          }
          let formData = { ...this.state.formData };
          this.setState({ AccPerList: [] }, () => {
            let defaultper = result[0].defaultPeriod;
            formData.AccPer = defaultper;
            this.setState({
              formData,
              AccPerList: accPeriod,
              hasEditPermission: "Yes",
              hasReimbursement: false,
              noEditPermission: false,
              selectdefaultperiod: defaultper,
            });
          });
        }
      });
  };

  GetAccountingPeriod = (requestlist: any, type: any) => {
    let accPeriod: any = [];
    registersevice
      .GetAccountingPeriod(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result !== null) {
            let hasEditPermission;
            if (result.length > 0) {
              result.forEach((element) => {
                let item: any = {};
                item.id = element.accperiod;
                item.name = element.accperiod;
                item.defaultPeriod = element.defaultPeriod;
                accPeriod.push(item);
              });

              let hasEntryButNotAccPer = true;
              let hasEntryandAccPer = true;
              let formData = { ...this.state.formData };
              let AccPer = moment(formData.AccPer).format("MM/DD/YY");
              hasEntryButNotAccPer = accPeriod.some(
                (item) => item.name === AccPer && item.defaultPeriod !== AccPer
              );
              hasEntryandAccPer = accPeriod.some(
                (item) => item.name === AccPer && item.defaultPeriod === AccPer
              );
              if (this.props.uniqueNo > 0) {
                this.setState({ voidAccPerList: [] }, () => {
                  let voidData = { ...this.state.voidData };
                  let defaultper = result[0].defaultPeriod;
                  const isCurrentPerActiveFound = accPeriod.some(
                    (item) => item.name === voidData.AccPer
                  );
                  if (!isCurrentPerActiveFound) voidData.AccPer = defaultper;
                  this.setState({ voidAccPerList: accPeriod, voidData });
                });
                if (hasEntryButNotAccPer) {
                  this.setState({ AccPerList: [] }, () => {
                    hasEditPermission = "Yes";
                    let defaultper = formData.AccPer;
                    formData.AccPer =
                      type === "hid" ? formData.AccPer : defaultper;
                    this.setState({
                      formData,
                      AccPerList: accPeriod,
                      hasEditPermission,
                      selectdefaultperiod: defaultper,
                    });
                  });
                } else if (hasEntryandAccPer) {
                  this.setState({ AccPerList: [] }, () => {
                    hasEditPermission = "Yes";
                    let defaultper = result[0].defaultPeriod;
                    formData.AccPer =
                      type === "hid" ? formData.AccPer : defaultper;
                    this.setState({
                      formData,
                      AccPerList: accPeriod,
                      hasEditPermission,
                      selectdefaultperiod: defaultper,
                    });
                  });
                } else if (this.props.isFromRepeating) {
                  this.setState({ AccPerList: [] }, () => {
                    hasEditPermission = "Yes";
                    let defaultper = result[0].defaultPeriod;
                    formData.AccPer =
                      type === "hid" ? formData.AccPer : defaultper;
                    this.setState({
                      formData,
                      AccPerList: accPeriod,
                      hasEditPermission,
                      selectdefaultperiod: defaultper,
                    });
                  });
                } else {
                  this.setState({ AccPerList: [] }, () => {
                    hasEditPermission = "No";
                    let formData = { ...this.state.formData };
                    let newArray = [
                      {
                        id: formData.AccPer,
                        name: formData.AccPer,
                        defaultPeriod: formData.AccPer,
                      },
                    ];
                    let defaultper = formData.AccPer;
                    formData.AccPer = type === "hid" ? formData.AccPer : defaultper;
                    this.setState({
                      formData,
                      AccPerList: newArray,
                      hasEditPermission,
                      selectdefaultperiod: defaultper,
                    });
                  });
                }
              } else {
                this.setState({ AccPerList: [] }, () => {
                  hasEditPermission = "Yes";
                  let defaultper: any = [];
                  let isBankSyncTransfer = this.props?.pageType === "BankSyncTransfer";
                  let BSDate = this.props?.accDetails?.date;
                  let getMonth = BSDate !== "" && new Date(new Date(BSDate).getFullYear(), new Date(BSDate).getMonth(), 1).toLocaleDateString();
                  let getActivePer = result.filter((o: any) => new Date(o.accperiod).toLocaleDateString() === getMonth && o.status.toString().toLocaleLowerCase() === 'active');
                  if (isBankSyncTransfer && getActivePer.length > 0) {
                    defaultper = getActivePer[0].accperiod
                  } else {
                    defaultper = result[0].defaultPeriod;
                  }
                  formData.AccPer = type === "hid" ? formData.AccPer : defaultper;
                  formData.UniqueNo = 0;
                  this.setState({
                    AccPerList: accPeriod,
                    formData,
                    hasEditPermission,
                    selectdefaultperiod: defaultper,
                  });
                });
              }
            } else {
              hasEditPermission = "No";
              this.setState({ hasEditPermission });
            }
          }
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        reject();
      });
  };

  GetAccountingToPeriod = (requestlist: any) => {
    let accPeriod: any = [];
    accPeriod = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.AccPerToList))
    );
    registersevice
      .GetAccountingPeriod(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          result.forEach((element) => {
            let item: any = {};
            item.id = element.accperiod;
            item.name = element.accperiod;
            accPeriod.push(item);
          });
          this.setState({ AccPerToList: [] }, () => {
            this.setState({ AccPerToList: accPeriod });
          });
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        reject();
      });
  };

  handleChange = (event: any, FieldType: string) => {
    let formData = { ...this.state.formData };
    let voidData = { ...this.state.voidData };
    let isStateChanged = true;
    if (FieldType === "Date") {
      let isDate = event === null ? new Date() : event;
      let today = new Date(isDate);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear();
      if (
        this.props
          ?.isFromRepeating
      ) {
        let selMon = today.getMonth() + 1;
        let selYear = today.getFullYear();
        let curDate = Utils.getHotalCurrentDate().getDate();
        let curMon = Utils.getHotalCurrentDate().getMonth() + 1;
        let curYear = Utils.getHotalCurrentDate().getFullYear();
        let posDate = new Date(this.state.oldTranDate).getDate();
        if (new Date(this.state.oldTranDate) > Utils.getHotalCurrentDate()) {
          if (
            new Date(this.state.oldTranDate) >
            new Date(curMon + "/" + curDate + "/" + curYear)
          ) {
            if (
              new Date(dateNew) <
              new Date(curMon + "/" + curDate + "/" + curYear) ||
              new Date(selMon + "/" + posDate + "/" + selYear) <
              Utils.getHotalCurrentDate()
            ) {
              Utils.toastError(
                "While editing an existing repeating entry, Post date should be greater or equal to the current date.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                }
              );
              return;
            } else {
              formData.Date = dateNew;
              formData.EndDate = "";
              this.setState({ formData });
            }
          }
        } else if (
          new Date(this.state.oldTranDate) < Utils.getHotalCurrentDate()
        ) {
          let curMonthName = Utils.getHotalCurrentDate().toLocaleString(
            "default",
            { month: "long" }
          );
          let seleMonthName = new Date(dateNew).toLocaleString("default", {
            month: "long",
          });
          if (
            new Date(seleMonthName + "-" + selYear) <=
            new Date(curMonthName + "-" + curYear)
          ) {
            Utils.toastError(
              "While editing an existing repeating entry, Post date should be greater or equal to the transaction date.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
              }
            );
            formData.Date = this.state.formData.Date;
            this.setState({ formData });
            return;
          } else {
            formData.Date = dateNew;
            formData.EndDate = "";
            this.setState({ formData });
          }
        }
      } else {
        formData.Date = dateNew;
        formData.StartDate = dateNew;
        formData.EndDate = "";
      }
    } else if (FieldType === "endDate") {
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear();
      formData.EndDate = dateNew;
    } else if (FieldType === "notes") {
      formData.Description = event.target.value;
    } else if (FieldType === "repeat") {
      formData.PaymentMethod =
        formData.PaymentMethod.toString().toLowerCase() ===
          "Check".toLocaleLowerCase()
          ? "Manual ACH"
          : formData.PaymentMethod;
      formData.RepType = event.target.checked ? "Yes" : "No";
      this.setState(
        {
          RepType: event.target.checked,
          isRowClick: false,
        },
        () => {
          let requestTo: any = {};
          requestTo.hotelID = this.state.formData.HIDTo;
          let checkOprFrom = formData.OprIdFrom === "" ? this.props?.accDetails?.oprID : formData.OprIdFrom;
          let checkOprto = formData.OprIdTo === "" ? this.props?.accDetails?.oprID : formData.OprIdTo;
          requestTo.OprIdFrom = (this.state.faccountName === "Select Account" ? checkOprto : checkOprFrom);
          requestTo.etype = "Transfer";
          this.GetAccountingToPeriod(requestTo);
        }
      );
    } else if (FieldType === "createOther") {
      this.setState({ createOther: event.target.checked, isRowClick: false });
    } else if (FieldType === "TransTotal") {
      let newVal = Utils.removeInvaildCharFromAmountNonMinus(
        event.target.value
      );
      event.target.value = newVal;
      const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
      let lenbeforePoint = 8;
      if (event.target.value.includes("-")) {
        lenbeforePoint = 9;
      }
      if (rx_live.test(event.target.value)) {
        if (event.target.value.includes(".")) {
          const timeArray = event.target.value?.split(".");
          if (
            timeArray[0].length <= lenbeforePoint &&
            timeArray[1].length <= 2
          ) {
            formData.TransTotal = event.target.value;
            formData.TransTotalHeader = !isNaN(event.target.value)
              ? event.target.value
              : "0.00";
          }
        } else {
          if (event.target.value.length <= lenbeforePoint) {
            formData.TransTotal = event.target.value;
            formData.TransTotalHeader = !isNaN(event.target.value)
              ? event.target.value
              : "0.00";
          }
        }
      } else if (
        event.target.value.includes(".") &&
        event.target.value.length === 1
      ) {
        formData.TransTotal = event.target.value;
        formData.TransTotalHeader = !isNaN(event.target.value)
          ? event.target.value
          : "0.00";
      }
    } else if (FieldType === "voidreason") {
      voidData.reason = event.target.value;
      this.setState({ voidData });
      return;
    } else if (FieldType === "VoidDate") {
      let isDate = event === null ? new Date() : event;
      let today = new Date(isDate);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear();

      let month: any = today.getMonth() + 1;
      let Year: any = today.getFullYear();
      if (month.toString().length < 2) {
        month = "0" + month;
      }
      if (Year.toString().length == 4) {
        Year = Year.toString().substring(2, 4);
      }
      let CuuPeriod = month + "/01/" + Year;
      let isExist = this.state.voidAccPerList.some(
        (item) => item.id === CuuPeriod
      );

      if (isExist) voidData.AccPer = CuuPeriod;
      else voidData.AccPer = "Select";

      voidData.Date = dateNew;
      this.setState({ voidData });
      return;
    }
    this.setState({ formData, isRowClick: false, isStateChanged, selectedRepeatType: FieldType === "repeat" ? "Monthly" : this.state.selectedRepeatType, });
  };

  amountBlur = (e) => {
    let formData = { ...this.state.formData };
    if (this.props?.pageType === "BankSyncTransfer") {
      formData.TransTotalHeader = this.props?.accDetails?.amount;
      formData.Date = this.props?.accDetails?.date;
    }
    formData.TransTotal = (e.target.value === "" ? "" : !isNaN(e.target.value) ? Utils.currencyFormatWithOutdoller(e.target.value) : 0);
    this.setState({ formData });
  };

  amountFocus = (e) => {
    let formData = { ...this.state.formData };
    let newval = Utils.removecurrencyFormat(e.target.value);
    formData.TransTotal = newval;
    this.setState({ formData });
  };

  endDatefocousOut(value) {
    let formData = { ...this.state.formData };
    if (value === "") {
      formData.EndDate = "";
      this.setState({ formData, isRowClick: false });
    }
  }

  onFileChange = (event: any, mode) => {
    let newfiles: any = [];
    if (event.target.files.length > 0) {
      for (let item of (event.target.files)) {
        let fileRow = item;
        newfiles.push(fileRow);
      }
      this.onDrop(newfiles);
      let fileList = document.getElementById("formControlsFile") as any;
      fileList.value = "";
    }
  };

  getFileSize() {
    registersevice.GetFileSize().then(async (result: any | null) => {
      if (result > 0) {
        this.setState({ fileSize: result });
      }
    });
  }

  onDrop = (filelist: any) => {
    let size = this.state.fileSize;
    let filesizeval = Number(Number(this.state.fileSize) / (1024 * 1024));
    let newfiles: any = [...this.state.newSelectedfiles];
    let isReturn = true;
    let filestext = "";

    filelist.forEach((element) => {
      if (element.size > size) {
        filestext = filestext + element.name + ",";
        isReturn = false;
      }
    });

    if (!isReturn) {
      let msg = "One or more files are greater than " + filesizeval + "MB.";
      Utils.toastError(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceInbox",
      });
    }
    let isInvalidFile = false;
    filelist.forEach((element) => {
      if (
        (element.name
          .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
          .toLowerCase() === "pdf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "doc" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "docx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xls" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xlsx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "csv" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "txt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "bmp" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "tif" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "ppt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "pptx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "rtf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpeg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "png" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "msg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "eml") &&
        element.size <= size
      ) {
        newfiles.push(element);
      } else {
        isInvalidFile = true;
      }
    });
    if (isInvalidFile && isReturn) {
      let msg = "";
      if (filelist.length === 1) {
        msg = "This file type is not supported.";
      } else {
        msg = "Some files are not supported.";
      }
      Utils.toastError(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "SaveTransfer",
      });
    }
    newfiles = _.sortBy(newfiles, "name");
    this.setState(
      { files: newfiles, newSelectedfiles: newfiles },
      () => {
        this.SaveTempWithFile(newfiles);
      }
    );
  };

  SaveTempWithFile(files: any) {
    this.setState({ currentScreenTop: 0 });
    let { formData, slideEntryType, tempUniqueNo } = this.state;
    let request: any = {};
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage?.tenantID);
    let accMod = (this.props.transferRequest.acctType === "" ? this.props.accDetails.acctType : this.props.transferRequest.acctType);
    let acctType =
      accMod === "O"
        ? "Operating"
        : accMod === "P"
          ? "Payroll"
          : accMod === "M" && "Miscellaneous";
    request.TenantID = tenantID;
    request.actionType = "";
    request.iscopyAttachment = "No";
    request.TempUniqueNo = this.state.RepType
      ? tempUniqueNo
      : slideEntryType === "newEntry"
        ? tempUniqueNo
        : "";
    request.UniqueNo = slideEntryType === "newEntry" ? 0 : formData.UniqueNo;
    request.oldUniqueNo =
      slideEntryType === "newEntry" ? 0 : formData.oldUniqueNo;
    request.TypeFrom =
      slideEntryType === "newEntry" ? acctType : formData.OldTypeFrom;
    request.OldTypeFrom =
      slideEntryType === "newEntry" ? "" : formData.OldTypeFrom;
    registersevice
      .SaveTempWithFile(request, files)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            this.setState({ isCopyHasAttachment: false }, () => {
              this.getUploadedFileList();
            });
          } else {
            Utils.toastError("Failed to upload attachment.", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            this.setState(
              { isDisabled: false, isCopyHasAttachment: false },
              () => {
                this.getUploadedFileList();
              }
            );
          }
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  handleSelectFileUpload = (eventKey: any, file, index) => {
    if (eventKey === "delete") {
      let newfiles: any = [];
      this.state.newSelectedfiles.forEach((element, idx) => {
        if (index !== idx) {
          newfiles.push(element);
        }
      });
      this.setState({
        newSelectedfiles: newfiles,
        files: newfiles,
        isRowClick: false,
      });
    } else if (eventKey === "download") {
      this.downloadTranactionFile(file);
    } else if (eventKey === "deleteFile") {
      confirmAlert({
        title: "Delete entry",
        message: "Are you sure you want to delete this entry?",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              let request: any = {};
              request.uniqueno = this.state.formData.UniqueNo;
              request.fileUniqueNo = file.fileUniqueno;
              request.type =
                this.state.slideEntryType === "newEntry"
                  ? "TempUploadFiles"
                  : this.state.formData.OldTypeFrom;
              request.isRepeat = this.state.formData.RepType;
              this.deleteTranactionFile(request, file);
            },
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
      });
    }
  };

  deleteTranactionFile = (request: any, file: any) => {
    let fileno = file.fileNo;

    registersevice
      .DeleteTransferFiles(request)
      .then(async (result: any | null) => {
        if (result.saveStatus === "Success") {
          this.getUploadedFileList();
          for (let i = 0; i < this.state.savedfiles.length; i++) {
            this["myRef" + i].current?.hanndleDeleteFile(Number(fileno));
          }
        } else {
          Utils.toastError(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "SaveTransfer",
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };
  downloadTranactionFile = (file: any) => {
    file.uniqueNo =
      this.state.slideEntryType === "newEntry"
        ? this.state.tempUniqueNo
        : file.uniqueNo;
    registersevice
      .DownloadTranactionFile(file)
      .then(async (result: any | null) => {
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        reject();
      });
  };

  handleSelectedData = (date: any, type: any) => {
    if (type === "voidAccPer") {
      let voidData = { ...this.state.voidData };
      voidData.AccPer = date;
      this.setState({ voidData });
    } else {
      let formData = { ...this.state.formData };
      formData.AccPer = date;
      this.setState({ formData, isRowClick: false, isStateChanged: true });
    }
  };

  fromCheckType = (event: any, type: any) => {
    let formData = { ...this.state.formData };
    formData.PaymentMethod = type;
    this.setState({ formData, isRowClick: false, isStateChanged: true });
  };

  getAccountFromNames = (registerRequest: any) => {
    registerRequest.UseForTransfer = this.state.isRowClick ? 1 : 0;
    let formData = { ...this.state.formData };
    registersevice
      .RegisterAccount(registerRequest)
      .then(async (result: any[] | null) => {
        if (result !== null) {
          let _result: any;
          let isResult = result.filter(
            (item) => item.acctType.toString().toLocaleLowerCase() !== "c"
          );
          if (this.state.isRowClick) {
            let hasFAccName = isResult.find(
              (item) => item.oprID === Number(formData.OprIdFrom)
            );
            let hasTAccName = isResult.find(
              (item) => item.oprID === Number(formData.OprIdTo)
            );
            if (formData.BackHID === formData.HIDTo) {
              if (typeof hasTAccName !== "undefined") {
                _result = isResult.filter(
                  (element) => element.name !== hasTAccName.name
                );
              } else {
                _result = isResult;
              }
            } else {
              _result = isResult;
            }
            this.setState(() => ({
              hasOP: hasFAccName !== undefined ? hasFAccName.name?.split("-")[1].trim() === "OPR" : "",
              faccountName: hasFAccName !== undefined ? hasFAccName.name : "Select Account",
              accountFromNamelist: _result,
              accountFromNamelist1: isResult,
            }));
          } else if (this.state.isFreshEntry) {

            let hasFAccName = isResult.filter(
              (item) => item.oprID === Number(this.props?.accDetails?.oprID)
            );
            if (hasFAccName.length > 0) {
              let hasGLVal: any = [];
              formData.OprIdFrom = hasFAccName[0].oprID;
              formData.TypeFrom = this.actType(hasFAccName[0]);
              this.setState(
                {
                  hasOP: hasFAccName[0].name.split("-")[1].trim() === "OPR",
                  formData,
                  faccountName: hasFAccName[0].name,
                  accountFromNamelist: isResult,
                  accountFromNamelist1: isResult,
                },
                () => {
                  let { glArray } = this.state;
                  glArray.forEach((item) => {
                    if (item === this.props?.accDetails.acctType) {
                      hasGLVal.push(item);
                    }
                  });
                  this.setState({ isGLPermission: this.state.faccountName === "Select Account" ? false : hasGLVal.length > 0 })
                  let clreqFrom: any = {};
                  clreqFrom.hotelID = this.props?.hidValue;
                  clreqFrom.ForTransferPage = 1;
                  this.transactionFromChartList(clreqFrom);
                  let event = { target: { value: this.props?.accDetails?.amount } }
                  setTimeout(() => {
                    this.amountBlur(event)
                  }, 1800);
                }
              );
            }
          } else {
            this.setState(() => ({
              accountFromNamelist: isResult,
              accountFromNamelist1: isResult,
              faccountName: "Select Account",
            }));
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  removeSelectedAccount = (from, accountName) => {
    let { accountToNamelist1, accountFromNamelist1 } = this.state;
    if (from === "From") {
      this.setState({
        accountToNamelist: accountToNamelist1.filter(function (element) {
          return element.name !== accountName;
        }),
      });
    } else {
      this.setState({
        accountFromNamelist: accountFromNamelist1.filter(function (element) {
          return element.name !== accountName;
        }),
      });
    }
  };

  handleAccountFromList = (event: any, account: any) => {
    this.setState({ fAccBalShow: true });
    let formData = { ...this.state.formData };
    // formData.BackHID === formData.HIDTo &&
    //   this.removeSelectedAccount("From", account.name);
    let { faccountName, glArray, isGLPermission } = this.state;

    let selectedAcc = account.acctType;
    let hasGLVal: any = [];
    glArray.forEach((item) => {
      if (item === selectedAcc) {
        hasGLVal.push(item);
      }
    });
    isGLPermission = hasGLVal.length > 0;
    faccountName = account.name;
    formData.OprIdFrom = account.oprID;
    formData.TypeFrom = this.actType(account);
    formData.OldTypeFrom = this.actTypeName(
      this.props.transferRequest.acctType
    );
    formData.PaymentMethod =
      account.name.split("-")[1].trim() !== "OPR"
        ? "Manual ACH"
        : formData.PaymentMethod;
    this.setState(
      {
        isFromAccountChange: true,
        isStateChanged: true,
        formData,
        faccountName,
        isRowClick: false,
        isGLPermission,
        hasOP: account.name.split("-")[1].trim() === "OPR",
      },
      () => {
        let reqFrom: any = {};
        reqFrom.hotelID = this.state.requestlist.hotelID;
        reqFrom.oprID = account.oprID;
        this.getAccountFromBal(reqFrom);
      }
    );
  };

  getAccountFromBal = (registerRequest: any) => {
    if (this.state.isRowClick) {
      this.setState({ fAccBalShow: true });
    }
    registersevice
      .RegisterAccountBal(registerRequest)
      .then(async (result: any[] | null) => {
        if (result !== null) {
          this.setState(
            {
              fAccBalData: result,
              fAccBal: parseFloat(result[0].accountBal.split(",").join("")),
            },
            () => {
              this.setState({
                fAccBalShow: false,
              });
            }
          );
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        reject();
      });
  };

  transactionFromChartList = (transactionRequest) => {
    let { formData, COAFromName, COAToName } = this.state;
    registersevice
      .GetTransactionChartList(transactionRequest)
      .then(async (result: any[] | null) => {
        if (result !== null) {
          let filterList: any = [];
          const map = new Map();
          for (const item of result) {
            if (!map.has(item.id)) {
              map.set(item.id, true);
              filterList.push({
                id: item.id,
                coAname: item.coAname,
                status: item.status,
                name: item.name,
                label: item.label,
                orderno: item.orderno,
              });
            }
          }
          let _result: any = [];
          let hasCOAFList: any = [];
          let hasCOATList: any = [];
          if (this.state.isRowClick) {
            if (formData.BackHID === formData.HIDTo) {
              hasCOAFList.push(filterList.find((item) => item.id));
              hasCOATList.push(filterList.find((item) => item.id));
              if (typeof hasCOAFList !== "undefined" && hasCOAFList !== null) {
                formData.COAFrom = hasCOAFList[0].id;
                COAFromName = hasCOAFList;
              } else {
                formData.COAFrom = "";
                COAFromName = [];
              }
              if (
                typeof hasCOATList[0] !== "undefined" &&
                hasCOATList[0] !== null
              ) {
                formData.COATo = hasCOATList[0].id;
                COAToName = hasCOATList;
              } else {
                formData.COATo = "";
                COAToName = [];
              }
              if (
                typeof hasCOATList[0] !== "undefined" &&
                hasCOATList[0] !== null &&
                typeof hasCOATList[0] !== "undefined" &&
                hasCOATList[0] !== null
              ) {
                this.setState({
                  COAFromName,
                  COAToName,
                  formData,
                  COAList: hasCOAFList,
                });
              } else {
                this.setState({
                  COAFromName,
                  COAToName,
                  formData,
                  COAList: filterList,
                });
              }
            } else {
              if (!this.state.hasReimbursement) {
                filterList = filterList.filter((item) => item.orderno !== 4);
              }
              filterList.filter(
                (item) =>
                  item.id === this.state.formData.COAFrom &&
                  hasCOAFList.push(item)
              );
              filterList.filter(
                (item) =>
                  item.id === this.state.formData.COATo &&
                  hasCOATList.push(item)
              );
              let isRepeatEntry = this.props?.isFromRepeating;
              if (hasCOAFList.length > 0) {
                COAFromName = hasCOAFList;
                formData.COAFrom = hasCOAFList[0].id;
              } else {
                let isArray = [
                  {
                    id: this.state.formData.COAFrom,
                    label: this.state.formData.COANameFrom,
                  },
                ];
                formData.COAFrom =
                  this.state.formData.isCOAPer1 === "No"
                    ? isArray[0].id
                    : isRepeatEntry
                      ? isArray[0].id
                      : "";
                COAFromName =
                  this.state.formData.isCOAPer1 === "No"
                    ? isArray
                    : isRepeatEntry
                      ? isArray
                      : [];
              }
              if (hasCOATList.length > 0) {
                formData.COATo = hasCOATList[0].id;
                COAToName = hasCOATList;
              } else {
                let isArray = [
                  {
                    id: this.state.formData.COATo,
                    label: this.state.formData.COANameTo,
                  },
                ];
                formData.COATo =
                  this.state.formData.isCOAPer2 === "No"
                    ? isArray[0].id
                    : isRepeatEntry
                      ? isArray[0].id
                      : "";
                COAToName = this.state.formData.isCOAPer2
                  ? isArray
                  : isRepeatEntry
                    ? isArray
                    : [];
              }
              if (
                typeof hasCOATList[0] !== "undefined" &&
                hasCOATList[0] !== null &&
                typeof hasCOATList[0] !== "undefined" &&
                hasCOATList[0] !== null
              ) {
                this.setState({
                  COAFromName,
                  COAToName,
                  formData,
                  COAList: hasCOAFList,
                });
              } else {
                this.setState({
                  COAFromName,
                  COAToName,
                  formData,
                  COAList: filterList,
                });
              }
            }
          } else if (this.state.isFreshEntry) {
            let flList: any = filterList.filter((item) => item.orderno === 4);
            formData.COAFrom = flList.length > 0 ? flList[0].id : "";
            formData.COANameFrom = flList.length > 0 ? flList[0].name : "";
            COAFromName = flList.length > 0 ? flList : [];
            formData.COATo = flList.length > 0 ? flList[0].id : "";
            formData.COANameTo = flList.length > 0 ? flList[0].name : "";
            COAToName = flList.length > 0 ? flList : [];
            let requestlist2 = { ...this.state.requestlist };
            requestlist2.hotelID = formData.HIDTo;
            let checkOprFrom = formData.OprIdFrom === "" ? this.props?.accDetails?.oprID : formData.OprIdFrom;
            let checkOprto = formData.OprIdTo === "" ? this.props?.accDetails?.oprID : formData.OprIdTo;
            requestlist2.OprIdFrom = (this.state.faccountName === "Select Account" ? checkOprto : checkOprFrom);
            requestlist2.etype = "Transfer";

            this.setState(
              { COAFromName, COAToName, formData, COAList: flList },
              () => {
                this.GetAccountingPeriod(this.state.requestlist, "");
                this.GetAccountingToPeriod(requestlist2);
              }
            );
          }
          if (formData.BackHID === formData.HIDTo) {
            _result = filterList.filter((item) => item.orderno === 4);
            if (_result.length > 0) {
              COAFromName = _result;
              COAToName = _result;
              formData.COAFrom = _result[0].id;
              formData.COATo = _result[0].id;
            } else {
              COAFromName = [];
              COAToName = [];
              formData.COAFrom = "";
              formData.COATo = "";
            }
            this.setState({
              COAFromName,
              COAToName,
              formData,
              COAList: _result,
            });
          } else {
            _result = filterList.filter((item) => item.orderno !== 4);
          }

          this.setState(() => ({ COAList: _result }));
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        reject();
      });
  };

  handleKeyDown = (event, type) => {
    if (event.key.toLowerCase() === "enter") {
      if (type === "droparea") {
        $("#droparea").focus();
      } else {
        this.setState({ createOther: !event.target.checked });
      }
    }
    if (event.key.toLowerCase() === "tab") {
      if (type === "droparea") {
        $("#chkAnother").focus();
      }
    }
  };

  getWebTimeClockManagerPermission = () => {
    let localStorageUser = JSON.parse(localStorage.getItem("storage")!);
    let requestObject = {} as IPageSubPermissionRole;
    requestObject.permissionID = 10088;
    requestObject.Module = "Accounting";
    requestObject.Type = "page";
    requestObject.RoleID = localStorageUser.rolId;
    requestObject.TenantID = localStorageUser.tenantID;
    RoleSubPermissionSetting.GetPageSubPermissionWebClockDetails(requestObject)
      .then(async (result: any | null) => {
        let { hasDeletePermission } = this.state;
        if (result != null && result.length > 0) {
          for (let item of result) {
            if (item?.permissionName.toString().toLowerCase() === "delete transfers" && item?.moduleName.toString().toLowerCase() === "accounting") {
              hasDeletePermission = true;
            }
          }
          let checkDel: any = {};
          checkDel.UniqueNo = this.state.formData.UniqueNo;
          checkDel.HID = this.state.formData.BackHID;
          checkDel.Type = this.actTypeName(this.props.transferRequest.acctType);
          this.setState({ hasDeletePermission }, () => {
            this.checkForDelete(checkDel);
          });
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        reject();
      });
  };

  checkForDelete = (request) => {
    Journalsevice.CheckForDelete(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          let hasAccess = result[0].result;
          if (hasAccess === "Yes") {
            this.setState({ hasDeleteAccess: true });
          } else {
            this.setState({ hasDeleteAccess: false });
          }
        } else {
          this.setState({ hasDeleteAccess: false });
          Utils.toastError("Something went wrong.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "SaveTransfer",
          });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ hasDeleteAccess: false });
        reject();
      });
  };

  hasDeletePermission(item: any, idx: any) {
    if (
      this.state.hasDeleteAccess &&
      this.state.hasDeletePermission &&
      item.name === "Delete"
    ) {
      return (
        <Dropdown.Item
          onClick={() => this.onMoreActionChange(item)}
          eventKey={this.state.moreAction[idx].eventKey}
          key={idx}
        >
          <>{this.state.moreAction[idx].name}</>
        </Dropdown.Item>
      );
    } else if (item.name !== "Delete") {
      return (
        <Dropdown.Item
          onClick={() => this.onMoreActionChange(item)}
          eventKey={this.state.moreAction[idx].eventKey}
          key={idx}
        >
          <>{this.state.moreAction[idx].name}</>
        </Dropdown.Item>
      );
    }
  }

  handleSelect = (eventKey: any) => {
    let { formData } = this.state;
    let deleteEntryReq: any = {};
    deleteEntryReq.UniqueNo = formData.UniqueNo;
    deleteEntryReq.Type = this.actTypeName(this.props.transferRequest.acctType);
    deleteEntryReq.HID = formData.BackHID;
    deleteEntryReq.isRepeat = this.props?.isFromRepeating ? 1 : 0;
    if (eventKey === "deleteTEntry") {
      this.deleteTransferEntry(deleteEntryReq);
    }
  };

  deleteTransferEntry = (request) => {
    confirmAlert({
      title: "Delete entry",
      message: "Are you sure you want to delete this entry?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            registersevice
              .DeleteTransferEntry(request)
              .then(async (result: any | null) => {
                if (
                  result.result.toString().toLowerCase() ===
                  "Success".toLocaleLowerCase()
                ) {
                  toast.success("Entry deleted successfully.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "SaveTransfer",
                  });
                  this.setState({ isChangeTr: true });
                  setTimeout(() => {
                    this.closeSlideOut();
                  }, 1500);
                } else {
                  Utils.toastError(result.result, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "SaveTransfer",
                  });
                }
                resolve();
              })
              .catch((error) => {
                this.setState({ hasDeleteAccess: false });
                reject();
              });
          },
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
    });
  };

  renderCOAItemChildren(option, props, index) {
    return (
      <>
        <div key={option.id}>
          <div className="vendor-name">
            <EllipsisWithTooltip placement="bottom">
              {option.label}
            </EllipsisWithTooltip>
          </div>
        </div>
      </>
    );
  }

  handleCOAKey = (event: any, type: any) => {
    let formData = { ...this.state.formData };
    if (event.keyCode === 8) {
      if (type === "COAFrom") {
        formData.COAFrom = "";
        this.setState({ formData, COAFromName: [], isStateChanged: true });
      } else {
        formData.COATo = "";
        this.setState({ formData, COAToName: [], isStateChanged: true });
      }
    }
  };

  COAControl = (item: any, type: any) => {
    let formData = { ...this.state.formData };
    this.setState({ isRowClick: false });
    if (type === "COAFrom") {
      if (item.length > 0) {
        formData.COAFrom = item[0].id;
        this.setState({ formData, COAFromName: item, isStateChanged: true });
      } else {
        formData.COAFrom = "";
        this.setState({ formData, COAFromName: [], isStateChanged: true });
      }
    } else if (type === "COATo") {
      if (item.length > 0) {
        formData.COATo = item[0].id;
        this.setState({ formData, COAToName: item, isStateChanged: true });
      } else {
        formData.COATo = "";
        this.setState({ formData, COAToName: [], isStateChanged: true });
      }
    }
  };

  transferControl = (type: any, item: any) => {
    let isBankSyncTransfer = this.props?.pageType === "BankSyncTransfer";
    let isBankSyncCheckW = (isBankSyncTransfer && this.props?.accDetails?.slideType?.toString().toLowerCase() === "checkwithdrawal");
    let isBankSyncWithdrawal = (isBankSyncTransfer && (isBankSyncCheckW || this.props?.accDetails?.slideType?.toString().toLowerCase() === "withdrawal"));

    let formData = { ...this.state.formData };
    if (type === "headerEhid") {
      let { HIDToNM } = this.state;
      HIDToNM = item.lettercode;
      formData.HIDTo = item.hotelID;
      formData.OprIdFrom = isBankSyncWithdrawal ? formData.OprIdFrom : "";
      formData.TypeFrom = isBankSyncWithdrawal ? formData.TypeFrom : "";
      formData.TypeTo = "";
      formData.OprIdTo = "";
      formData.COAFrom = "";
      formData.COATo = "";
      formData.PaymentMethod = "Manual ACH";
      formData.isCOAPer1 = "Yes";
      formData.isCOAPer2 = "Yes";
      let reqTo: any = {};
      let reqFrom: any = {};
      let requestlist: any = {};
      requestlist.hotelID = item.hotelID;
      let checkOprFrom = formData.OprIdFrom === "" ? this.props?.accDetails?.oprID : formData.OprIdFrom;
      let checkOprto = formData.OprIdTo === "" ? this.props?.accDetails?.oprID : formData.OprIdTo;
      requestlist.OprIdFrom = (this.state.faccountName === "Select Account" ? checkOprto : checkOprFrom);
      requestlist.etype = "Transfer";
      reqTo.hotelID = formData.HIDTo;
      reqFrom.hotelID = this.state.requestlist.hotelID;
      let clreqFrom: any = {};
      clreqFrom.hotelID = this.state.requestlist.hotelID;
      clreqFrom.ForTransferPage = 1;
      this.setState(
        {
          isStateChanged: true,
          formData,
          accountToNamelist: [],
          accountFromNamelist: isBankSyncWithdrawal ? this.state.accountFromNamelist : [],
          AccPerToList: [],
          fAccBalShow: isBankSyncWithdrawal ? false : true,
          fAccBal: isBankSyncWithdrawal ? this.state.fAccBal : 0.0,
          fAccBalData: isBankSyncWithdrawal ? this.state.fAccBalData : [],
          COAList: [],
          COAFromName: [],
          COAToName: [],
          HIDToNM,
          hasOP: isBankSyncWithdrawal,
          isRowClick: false,
          isComment: true,
          htmlcomment: [],
          isFreshEntry: false,
        },
        () => {
          this.getAccountToNames(reqTo);
          !isBankSyncWithdrawal && this.getAccountFromNames(reqFrom);
          this.transactionFromChartList(clreqFrom);
          this.GetAccountingToPeriod(requestlist);
          this.GetAccountingPeriod(requestlist, "hid");
        }
      );
    }
  };

  getAccountToNames = (registerRequest: any) => {
    registerRequest.UseForTransfer = 1;
    let formData = { ...this.state.formData };
    registersevice
      .RegisterAccount(registerRequest)
      .then(async (result: any[] | null) => {
        if (result !== null) {
          let _result: any;
          let isResult = result.filter(
            (item) => item.acctType.toString().toLocaleLowerCase() !== "c"
          );
          if (this.state.isRowClick) {
            let hasTAccName = isResult.find(
              (item) => item.oprID == formData.OprIdTo
            );
            let hasFAccName = isResult.find(
              (item) => item.oprID == formData.OprIdFrom
            );
            if (formData.BackHID === formData.HIDTo) {
              if (typeof hasFAccName !== "undefined") {
                _result = isResult.filter(
                  (element) => element.name !== hasFAccName.name
                );
              } else {
                _result = isResult;
              }
            } else {
              _result = isResult;
            }
            this.setState(() => ({
              accountToNamelist: _result,
              accountToNamelist1: isResult,
              taccountName: hasTAccName?.name,
            }));
          } else if (this.state.isFreshEntry) {
            let hasFAccName = isResult.filter(
              (item) => item.oprID === Number(this.props?.accDetails?.oprID)
            );
            if (hasFAccName.length > 0) {
              _result = isResult.filter(
                (element) => element.name !== hasFAccName[0].name
              );
            } else {
              _result = isResult;
            }
            let hasTOAccName = isResult.filter(
              (item) => item.oprID === Number(this.props?.accDetails?.oprID)
            );
            let { formData } = this.state;
            formData.OprIdTo = "";
            formData.TypeTo = this.actType(hasTOAccName[0]);
            this.setState(() => ({
              taccountName: "Select Account",
              accountToNamelist: _result,
              accountToNamelist1: isResult,
              formData
            }));
          } else {
            this.setState(() => ({
              accountToNamelist: isResult,
              accountToNamelist1: isResult,
              taccountName: "Select Account",
            }));
          }
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        reject();
      });
  };

  handleAccountToList = (account: any) => {
    let formData = { ...this.state.formData };
    formData.BackHID === formData.HIDTo && this.removeSelectedAccount("To", account.name);
    let { taccountName } = this.state;
    taccountName = account.name;
    formData.OprIdTo = account.oprID;
    formData.TypeTo = this.actType(account);
    this.setState({
      formData,
      taccountName,
      isRowClick: false,
      isStateChanged: true,
    });
  };
  //--TO
  resetState = () => {
    this.setState(
      {
        isStateChanged: false,
        AccPerList: [],
        AccPerToList: [],
        hidListCount: [],
        newSelectedfiles: [],
        RepType: this.state.RepType,
        hasOP: false,
        logInUserID: "",
        accountFromNamelist: [],
        accountToNamelist: [],
        createOther: false,
        tabEnable: 0,
        savedfiles: [],
        files: [],
        spliHIDToList: [],
        BackHIDNM: this.state.BackHIDNM,
        fAccBalData: [],
        fAccBalShow: false,
        COAList: [],
        faccountName: "Select Account",
        fAccBal: 0.0,
        COAFromName: [],
        HIDToNM: "Choose an EHID",
        taccountName: "Select Account",
        COAToName: [],
        alertModalshow: false,
        dateArray: [],
        hasActiveMonth1: [],
        hasActiveMonth2: [],
        isChangeTr: this.state.isChangeTr,
        isDisable: false,
        isComment: false,
        htmlcomment: [],
        isOpenViewer: false,
        formData: {
          UniqueNo: this.state.formData.UniqueNo,
          TenantID: this.state.formData.TenantID,
          Date: null,
          AccPer: "Accounting Period",
          BackHID: this.props.hidValue,
          HIDTo: "",
          TypeFrom: "",
          OldTypeFrom: "",
          TypeTo: "",
          OprIdFrom: this.state.formData.OprIdFrom,
          OprIdTo: "",
          COAFrom: "",
          COATo: "",
          TransTotal: "",
          TransTotalHeader: "",
          RepUniqueNo: 0,
          Description: "",
          RepType: this.state.formData.RepType,
          StartDate: "",
          EndDate: "",
          PaymentMethod: "Manual ACH",
          transferLogID: 0,
          isCOAPer1: "Yes",
          isCOAPer2: "Yes",
        },
      },
      () => {
        this.reCallApis();
      }
    );
  };

  checkACM = (startDate, endDate) => {
    let { AccPerList, AccPerToList } = this.state;
    let cDate;
    let firstDay;
    let dateArray: any = [];
    let hasinM1: any = [];
    let hasinM2: any = [];
    let fDm1: any = [];
    let fDm2: any = [];
    while (startDate <= endDate) {
      cDate = new Date(startDate);
      firstDay = new Date(
        cDate.getFullYear(),
        cDate.getMonth(),
        1
      ).toLocaleDateString();
      dateArray.push(firstDay);
      startDate.setUTCDate(startDate.getUTCDate() + 31);
    }
    for (let itm of AccPerList) {
      fDm1.push(new Date(itm?.name).toLocaleDateString());
    }
    for (let jtm of AccPerToList) {
      fDm2.push(new Date(jtm?.name).toLocaleDateString());
    }
    for (let ktm of dateArray) {
      fDm1.filter((items) => items === ktm && hasinM1.push(ktm));
    }
    for (let ltm of dateArray) {
      fDm2.filter((items) => items === ltm && hasinM2.push(ltm));
    }
    return (hasinM1.length === 0 || hasinM2.length === 0);
  };

  checkValidation = (request: any) => {
    let isCOAPer1 = this.state.formData.isCOAPer1 === "Yes";
    let isCOAPer2 = this.state.formData.isCOAPer2 === "Yes";

    let trResponse = "";
    let todaysDate = Utils.getHotalCurrentDate();
    todaysDate = new Date(todaysDate.setHours(0, 0, 0, 0));
    if (this.state.isCheckEntry && this.state.files.length > 0) {
    } else {
      let isRYN = this.state.hasRecouncil ? false : false;
      if (
        this.state.isTrEntryPaid
          ? isRYN && request.PaymentMethod === "Check"
          : request.PaymentMethod === "Check"
      ) {
        if (new Date(request.Date) < todaysDate) {
          trResponse = "Date Should be greater than or equal to Current Date";
          return trResponse;
        }
      }
    }
    if (request.RepType === "No") {
      if (request.Date === null) {
        trResponse = "Please Select transfer date.";
        return trResponse;
      } else if (request.AccPer === "Accounting Period") {
        trResponse = "Please Select account period.";
        return trResponse;
      }
    } else if (request.RepType === "Yes") {
      let reqDate = new Date(request.Date);
      let reqEndDate = new Date(request.EndDate);
      if (request.Date === null) {
        trResponse = "Please Select transfer date.";
        return trResponse;
      } else if (request.EndDate !== "") {
        if (reqEndDate <= reqDate) {
          trResponse = "End Date should be greater than Transfer Date.";
          return trResponse;
        } else {
          if (request.HIDTo === "") {
            trResponse = "Please select transfer to EHID.";
            return trResponse;
          } else {
            let tM = new Date(request.Date).getMonth() + 1;
            let tY = new Date(request.Date).getFullYear();
            let accPer = tM + "/01/" + tY;
            let startDate = new Date(accPer);
            let reqEndDate = new Date(request.EndDate);
            let tM2 = new Date(todaysDate).getMonth() + 1;
            let tY2 = new Date(todaysDate).getFullYear();
            let todaysDate2 = tM2 + "/01/" + tY2;
            let endDate = reqEndDate > new Date(todaysDate2) ? new Date(todaysDate2) : reqEndDate;
            let hasACM = this.checkACM(startDate, endDate);
            if (hasACM) {
              let trResponse = "All the accounting periods from the selected date till current date should be active.";
              return trResponse;
            }
          }
        }
      } else {
        if (request.HIDTo === "") {
          trResponse = "Please select transfer to EHID.";
          return trResponse;
        } else {
          let tM = new Date(request.Date).getMonth() + 1;
          let tY = new Date(request.Date).getFullYear();
          let accPer = tM + "/01/" + tY;
          let startDate = new Date(accPer);
          let tM2 = new Date(todaysDate).getMonth() + 1;
          let tY2 = new Date(todaysDate).getFullYear();
          let todaysDate2 = tM2 + "/01/" + tY2;
          let endDate = new Date(todaysDate2);
          if (new Date(startDate).getMonth() + 1 <= new Date().getMonth() + 1) {
            let hasACM = this.checkACM(startDate, endDate);
            if (hasACM) {
              let trResponse =
                "All the accounting periods from the selected date till current date should be active.";
              return trResponse;
            }
          }
        }
      }
    }
    if (request.HIDTo === "") {
      trResponse = "Please select transfer to EHID.";
      return trResponse;
    } else if (request.OprIdFrom === "") {
      trResponse = "Please select from account.";
      return trResponse;
    } else if (isCOAPer1 && request.COAFrom === "") {
      trResponse = "Please select from COA.";
      return trResponse;
    } else if (request.TransTotal === "") {
      trResponse = "Amount can't be blank.";
      return trResponse;
    } else if (request.TypeTo === "") {
      trResponse = "Please select to account type.";
      return trResponse;
    } else if (request.OprIdTo === "") {
      trResponse = "Please select to account.";
      return trResponse;
    } else if (isCOAPer2 && request.COATo === "") {
      trResponse = "Please select to COA.";
      return trResponse;
    } else if (
      request.BackHID === request.HIDTo &&
      request.OprIdFrom === request.OprIdTo
    ) {
      trResponse = "Transfer FROM and Transfer TO Account Name can't be same.";
      return trResponse;
    } else if (
      request.BackHID === request.HIDTo &&
      request.COAFrom !== request.COATo
    ) {
      trResponse = "Transfers within the same HID should have same COA.";
      return trResponse;
    } else {
      return (trResponse = "Valid");
    }
  };

  alertModalShow = () => {
    this.setState({ alertModalshow: true });
  };
  alertModalHide = () => {
    this.setState({ alertModalshow: false, isDisable: false });
  };
  voidModalHide = () => {
    this.setState({ voidModal: false });
  };

  checkOpeningDate = (request, files) => {
    let { formData } = this.state;
    let chkreq: any = {};
    chkreq.HID = formData.BackHID;
    chkreq.OPRID = (this.state.faccountName === "Select Account" ? formData.OprIdTo : formData.OprIdFrom);
    chkreq.Date = formData.Date;
    registersevice
      .CheckACCOpeningDateStatusByDate(chkreq)
      .then(async (result: any | null) => {
        if (result.success) {
          let data = result?.result?.result;
          if (data.toString().toLocaleLowerCase() === "valid") {
            this.saveTransfer(request, files);
          } else {
            this.setState({ isDisable: false });
            Utils.toastError(
              "Payment Date should not be less than account opening date.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveTransfer",
              }
            );
          }
        } else {
          this.setState({ isDisable: false });
          Utils.toastError("Something went wrong.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "SaveTransfer",
          });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isDisable: false });
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        reject();
      });
  };

  saveDepositeEntry = () => {
    this.setState({ alertModalshow: false });
    let request: any = {};
    request = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.state.formData))
    );
    this.checkOpeningDate(request, this.state.files);
  };

  saveDeposit = () => {
    let request: any = {};
    request = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.state.formData))
    );
    request.TransTotal = Utils.removecurrencyFormat(request.TransTotal);
    if (this.ChildComment.current?.isCommentAdd()) {
      Utils.toastError("Please add your comments.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "SaveTransfer",
      });
      return false;
    }

    let trResponse = this.checkValidation(request);
    if (trResponse !== "" && trResponse !== "Valid") {
      Utils.toastError(trResponse, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "SaveTransfer",
      });
      return;
    }
    if (trResponse === "Valid") {
      request.TransTotal = Number(request.TransTotal).toFixed(2);
      let todaysDate = new Date();
      todaysDate.setHours(0, 0, 0, 0);
      this.setState({ isDisable: true });
      if (
        new Date(request.Date) > todaysDate &&
        request.PaymentMethod !== "Check"
      ) {
        this.alertModalShow();
      } else {
        this.checkOpeningDate(request, this.state.files);
      }
    }
  };

  saveTransfer = (request, files) => {
    let userComments: any = [];
    userComments = this.ChildComment.current?.CommentToSave();
    request.UserComments = userComments;
    request.AccPer = moment(request.AccPer).format("DD-MMM-YYYY");
    request.Date = moment(request.Date).format("DD-MMM-YYYY");
    request.StartDate = moment(request.StartDate).format("DD-MMM-YYYY");
    request.EndDate =
      request.EndDate === ""
        ? ""
        : moment(request.EndDate).format("DD-MMM-YYYY");

    request.PaymentMethod =
      request.PaymentMethod.toString().toLowerCase() ===
        "Manual ACH".toLowerCase()
        ? "ACH"
        : request.PaymentMethod;
    request.OldTypeFrom =
      this.state.slideEntryType === "newEntry"
        ? "TempUploadFiles"
        : this.actTypeName(this.props.transferRequest.acctType);
    request.TempUniqueNo = this.state.RepType
      ? this.state.tempUniqueNo
      : this.state.slideEntryType === "newEntry"
        ? this.state.RepType
          ? ""
          : this.state.tempUniqueNo
        : "";
    let isPageType: any = ''
    if (request.TypeFrom === "Payroll") {
      isPageType = 'PayrollTransferEntry'
    } else if (request.TypeFrom === "Miscellaneous") {
      isPageType = 'MIStransfer'
    } else {
      isPageType = "Transfer"
    }
    request.repeatType = this.state.RepType ? this.state.selectedRepeatType : "";
    registersevice
      .SaveTransfer(request, files)
      .then(async (result: any | null) => {
        if (result !== null) {
          let message = "";
          let messageCode = "";
          if (
            result.saveStatus.toString().toLocaleLowerCase() ===
            "Fail".toLocaleLowerCase()
          ) {
            messageCode = result.messageCode.toString().toLocaleLowerCase();
            if (messageCode === "LessThanFromACCOpen".toLocaleLowerCase()) {
              message =
                "Payment Date should not be less than the account opening date.";
            } else if (
              messageCode === "LessThanToACCOpen".toLocaleLowerCase()
            ) {
              message =
                "Payment Date should not be less than the account opening date.";
            } else if (
              messageCode === "LessThanFromEHIDOpen".toLocaleLowerCase()
            ) {
              message =
                "Transfer date can not be less then the EHDI Account opening date.";
            } else {
              message = result.message;
            }
            this.setState({ isDisable: false });
            Utils.toastError(message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "SaveTransfer",
            });
          } else if (result.saveStatus === null) {
            message = "Something went wrong.";
            this.setState({ isDisable: false });
            Utils.toastError(message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "SaveTransfer",
            });
          } else if (result.saveStatus === "Success") {
            toast.success(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "SaveTransfer",
            });
            this.setState({
              isDisable: false,
              isCopyEntry: false,
              alertModalshow: false,
              isChangeTr: true,
            });
            if (!this.state.createOther) {
              if (this.props.transationSlideoutSave !== undefined) {
                request.pageType = isPageType;
                request.uniqueno = result.uniqueno;
                debugger;
                this.props.transationSlideoutSave(request, result);
              }
              setTimeout(() => {
                this.closeSlideOut();
              }, 3000);
            }
            setTimeout(() => {
              this.resetState();
            }, 3500);
          } else {
            this.setState({ isDisable: false });
            message = result.message.replace("Transaction", "Transfer");
            Utils.toastError(message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "SaveTransfer",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ alertModalshow: false, isDisable: false });
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "SaveTransfer",
        });
        reject();
      });
  };

  handleFileCheckBox = (event, files, fileNo, selectedId, chktype) => {
    if (chktype === "bulkSelect") {
      if (!event.target.checked) {
        this.setState({ chkIds: [], selectedChk: [] });
      } else {
        const newIds = [...this.state.chkIds];
        files.forEach((element) => {
          for (let inx = 0; inx < element.totalpage; inx++) {
            let id = element.fileNo.toString() + "_" + inx.toString();
            const selectedId1 = `custom_${id}`;
            const newId = this.state.chkIds.filter((x) => x.id === selectedId1);
            if (newId.length === 0) {
              let item: any = {};
              item.id = selectedId1;
              item.fileNo = element.fileNo;
              newIds.push(item);
            }
          }
          this.setState({ chkIds: newIds });
        });
      }
    } else if (chktype === "All") {
      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.fileNo !== fileNo);
        this.setState({ chkIds: newIds });
      } else {
        const newIds = [...this.state.chkIds];
        files
          .filter((x) => x.fileNo === fileNo)
          .forEach((element) => {
            for (let inx = 0; inx < element.totalpage; inx++) {
              let id = element.fileNo.toString() + "_" + inx.toString();
              const selectedId1 = `custom_${id}`;
              const newId = this.state.chkIds.filter(
                (x) => x.id === selectedId1
              );
              if (newId.length === 0) {
                let item: any = {};
                item.id = selectedId1;
                item.fileNo = element.fileNo;
                newIds.push(item);
              }
            }
            this.setState({ chkIds: newIds });
          });
      }
    } else {
      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.id !== selectedId);
        this.setState({ chkIds: newIds });
      } else {
        const newIds = [...this.state.chkIds];
        let item: any = {};
        item.id = selectedId;
        item.fileNo = fileNo;
        newIds.push(item);
        this.setState({ chkIds: newIds });
      }
    }
  };

  hideBulkselect = () => {
    this.setState({ bulkSelect: false, chkIds: [], selectedChk: [] });
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.hideBulkSelect();
    }
  };

  OpenViewer = () => {
    if (this.state.bulkSelect && this.state.isOpenViewer) {
      this.hideBulkselect();
    }
    this.setState(
      (prevState) => ({
        isOpenViewer: !prevState.isOpenViewer,
        defaultView: "doc-view",
      }),
      () => {
        if (this.state.isOpenViewer) {
          setTimeout(() => {
            const innerWidthSec = this.scrollheight.current
              .getElement()
              .getBoundingClientRect().height;
            this.setState({ scrollAreaHeight: innerWidthSec });
          }, 100);
        }
      }
    );
  };

  handleUpdatedFile = () => {
    return this.state.chkIds;
  };

  handleincompleteFile() {
    return this.state.newSelectedfiles;
  }

  handleZoom = (event) => {
    let currZoom = this.state.currentZoom;
    let updateZoom;
    if (event === "zoomIn") {
      updateZoom = currZoom * 1.5;
    } else {
      updateZoom = currZoom / 1.5;
    }
    this.setState({ currentZoom: updateZoom });
  };

  handleAllCheckbox = (event) => {
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.handleAllCheckbox(event);
    }
  };

  handleBulkRotate = () => {
    this.handleRotate(this.state.chkIds, 0, 0);
  };

  handleBulkRemove = () => {
    this.handlePageRemove(this.state.chkIds, 0, 0);
  };

  handleRotate = (chkIds, currentfileNo, currentPage) => {
    let scrollPos = this.scrollheight.current.getElement().scrollTop;
    this.setState({ currentScreenTop: scrollPos });
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage?.tenantID);
    let selectedRotateFile: any = [];
    let accMod = (this.props.transferRequest.acctType === "" ? this.props.accDetails.acctType : this.props.transferRequest.acctType);
    let acctType =
      accMod === "O"
        ? "Operating"
        : accMod === "P"
          ? "Payroll"
          : accMod === "M" && "Miscellaneous";
    if (chkIds.length > 0) {
      for (let x = 0; x < chkIds.length; x++) {
        let splitchkIds: any = [];
        splitchkIds = chkIds[x].id.toString().split("_");
        let fileNo = Number(splitchkIds[1]);
        let pageNo = Number(splitchkIds[2]) + 1;
        let savedFileDet = this.state.savedfiles.filter(
          (e) => e.fileUniqueno === fileNo
        );
        let item: any = {};
        item.hotelID = this.state.formData.hotelID;
        item.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet[0].uniqueNo;
        item.uploadFile = savedFileDet[0].uploadFile;
        item.fileNo = fileNo;
        item.pageNo = pageNo;
        item.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : acctType;
        item.tenantID = this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item);
      }
    }
    if (currentfileNo > 0) {
      let isExist = selectedRotateFile.filter(
        (y) => y.fileNo === currentfileNo && y.pageNo === currentPage
      );
      if (isExist.length === 0) {
        let item1: any = {};
        let savedFileDet1 = this.state.savedfiles.filter(
          (e1) => e1.fileUniqueno === currentfileNo
        );
        item1.hotelID = this.state.formData.hotelID;
        item1.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet1[0].uniqueNo;
        item1.uploadFile = savedFileDet1[0].uploadFile;
        item1.fileNo = currentfileNo;
        item1.pageNo = currentPage;
        item1.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : acctType;
        item1.tenantID =
          this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item1);
      }
    }
    if (selectedRotateFile.length > 0) {
      this.saveRotation(selectedRotateFile, chkIds);
    } else {
      toast.success("Please select atleast one page to rotate.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "SaveTransfer",
      });
    }
  };

  saveRotation = (request, chkIds) => {
    this.setState({ isSpinner: true });
    registersevice
      .RotatePDf(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            if (request.length === 1) {
              toast.success("Page rotated successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveCreditCard",
              });
            } else {
              toast.success("Pages rotated successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveCreditCard",
              });
            }

            this.setState({ selectedChk: chkIds }, () => {
              this.getUploadedFileList();
            });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "SaveCreditCard",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  handlePageRemove = (chkIds, currentfileNo, currentPage) => {
    let scrollPos = this.scrollheight.current.getElement().scrollTop;
    this.setState({ currentScreenTop: scrollPos });
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage?.tenantID);
    let selectedRotateFile: any = [];
    let accMod = (this.props.transferRequest.acctType === "" ? this.props.accDetails.acctType : this.props.transferRequest.acctType);
    let acctType =
      accMod === "O"
        ? "Operating"
        : accMod === "P"
          ? "Payroll"
          : accMod === "M" && "Miscellaneous";
    if (chkIds.length > 0) {
      for (let x = 0; x < chkIds.length; x++) {
        let splitchkIds: any = [];
        splitchkIds = chkIds[x].id.toString().split("_");
        let fileNo = Number(splitchkIds[1]);
        let pageNo = Number(splitchkIds[2]) + 1;
        let savedFileDet = this.state.savedfiles.filter(
          (e) => e.fileUniqueno === fileNo
        );
        let item: any = {};
        item.hotelID = this.state.formData.hotelID;
        item.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet[0].uniqueNo;
        item.uploadFile = savedFileDet[0].uploadFile;
        item.fileNo = fileNo;
        item.pageNo = pageNo;
        item.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : acctType;
        item.tenantID = this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item);
      }
    }
    if (currentfileNo > 0) {
      let isExist = selectedRotateFile.filter(
        (y) => y.fileNo === currentfileNo && y.pageNo === currentPage
      );
      if (isExist.length === 0) {
        let item1: any = {};
        let savedFileDet1 = this.state.savedfiles.filter(
          (e1) => e1.fileUniqueno === currentfileNo
        );
        item1.hotelID = this.state.formData.hotelID;
        item1.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet1[0].uniqueNo;
        item1.uploadFile = savedFileDet1[0].uploadFile;
        item1.fileNo = currentfileNo;
        item1.pageNo = currentPage;
        item1.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : acctType;
        item1.tenantID =
          this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item1);
      }
    }
    if (selectedRotateFile.length > 0) {
      this.saveRemovepage(selectedRotateFile, chkIds);
    } else {
      toast.success("Please select atleast one page to remove.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "SaveTransfer",
      });
    }
  };

  saveRemovepage = (request, chkIds) => {
    this.setState({ isSpinner: true });
    registersevice
      .RemovePDFPage(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            if (request.length === 1) {
              toast.success("Page removed successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveTransfer",
              });
            } else {
              toast.success("Pages removed successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveTransfer",
              });
            }

            this.setState({ selectedChk: [chkIds], isSave: true }, () => {
              this.getUploadedFileList();
              this.hideBulkselect();
            });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "SaveTransfer",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };
}